import React, { useEffect, useState } from 'react';

import { useSelector } from "react-redux";
import Carousel from 'react-material-ui-carousel'
import { useNavigate } from 'react-router-dom'
import PositionedSnackbar from "../../components/general/PositionedSnackbar";
import { useDispatch } from 'react-redux'
import Config from '../../config'
import GeneralStyles from '../GeneralStyles.module.scss'
import CustomLoaderSpinner from "../../components/general/CustomLoaderSpinner";
import PageHeader from "../../components/general/PageHeader";
import CustomTextFieldNative from "../../components/general/CustomTextFieldNative";
import Colors from "../../config/colors";
import SearchIcon from '@mui/icons-material/Search';
import Constants from "../../config/constants";
import Styles from './styles/UnderwritingDetails.module.scss';
import WorkOrdersList from '../../metadata/work_orders.json'
import moment from "moment";
import {LOGGER} from "../../utils/Logger";
import axios from "axios";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from '@mui/material/TableBody';
import Table from '@mui/material/Table';
import {API_CALL_STATUS, WORK_ORDER_STATUSES} from "../../metadata/enums";
import {getAssumptionsSettings, updateSettingsUpdatedStatus} from "../../redux/slices/settingsSlice";
import {changeUserAccess} from "../../redux/slices/authSlice";
import CONSTANTS from "../../config/constants";
import CustomModal from "../../components/general/CustomModal";
import CustomTextFieldNew from "../../components/general/CustomTextFieldNew";
import {Edit, Help} from "@mui/icons-material";
import CustomButtonContained from "../../components/general/CustomButtonContained";
import LoanTiersTable from "../../components/general/Loans/LoanTiersTable";
import Helpers from "../../utils/helpers";
import ApiHelpers from "../../utils/ApiHelpers";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import {
	updateActiveUnderwriting,
	updateActiveUnderwritingId,
	updateWorkOrderStatus,
	updateWorkOrderStatusFlag
} from '../../redux/slices/workOrdersSlice';
import CustomSelect from "../../components/general/CustomSelect";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {Accordion, AccordionDetails, AccordionSummary} from "@mui/material";
import {Calendar} from "react-date-range";
import {isNaN} from "underscore";

const DATE_FORMAT = 'MMM Do, YYYY'

const DATA = {
	actuals: {
		rental_income: {value: 0, percent: 0},
		pet_income: {value: 0, percent: 0},
		other_income: {value: 0, percent: 0},
    vacancy: {value: 0, percent: 0},
		property_taxes: {value: 0, percent: 0},
    management_fees: {value: 0, percent: 0},
    lease_fees: {value: 0, percent: 0},
		insurance: {value: 0, percent: 0},
		repairs_maintenance: {value: 0, percent: 0},
    cap_ex_reserve: {value: 0, percent: 0},
    other: {value: 0, percent: 0},
	},
	proforma: {
		rental_income: {value: 0, percent: 0},
		pet_income: {value: 0, percent: 0},
		other_income: {value: 0, percent: 0},
		vacancy: {value: 0, percent: 0},
		property_taxes: {value: 0, percent: 0},
		management_fees: {value: 0, percent: 0},
		lease_fees: {value: 0, percent: 0},
		insurance: {value: 0, percent: 0},
		repairs_maintenance: {value: 0, percent: 0},
		cap_ex_reserve: {value: 0, percent: 0},
		other: {value: 0, percent: 0},
	},
	manual: {
		rental_income: {value: 0, percent: 0},
		pet_income: {value: 0, percent: 0},
		other_income: {value: 0, percent: 0},
		vacancy: {value: 0, percent: 0},
		property_taxes: {value: 0, percent: 0},
		management_fees: {value: 0, percent: 0},
		lease_fees: {value: 0, percent: 0},
		insurance: {value: 0, percent: 0},
		repairs_maintenance: {value: 0, percent: 0},
		cap_ex_reserve: {value: 0, percent: 0},
		other: {value: 0, percent: 0},
	},
}

const EXPANDABLE_ROWS = {
	work_order_details: 'work_order_details',
	income_details: 'income_details',
	third_party_details: 'third_party_details',
	attom_sales_comps: 'attom_sales_comps',
	zillow_sales_comps: 'zillow_sales_comps',
	rental_comps: 'rental_comps',
	loan_tiers: 'loan_tiers',
	loan_options: 'loan_options',
}

export default function UnderwritingDetails() {
	let dispatch = useDispatch()
	let navigate = useNavigate()

	const activeUnderwriting = useSelector(state => state.workOrders.active_underwriting)
	const activeUnderwritingId = useSelector(state => state.workOrders.active_underwriting_id)
	const token = useSelector(state => state.auth.token)
	const settingsState = useSelector(state => state.settings)
	const workOrdersState = useSelector(state => state.workOrders)

	const [mortgageExpanded, setMortgageExpanded] = useState(false)
	const [expanded, setExpanded] = useState(['work_order_details', 'third_party_details', 'income_details', 'loan_options'])
	const [showExpensesModal, setShowExpensesModal] = useState(false)
	const [showIncomeModal, setShowIncomeModal] = useState(false)
	const [zillowDataLoading, setZillowDataLoading] = useState(false)
	const [attomDataLoading, setAttomDataLoading] = useState(false)
	const [assumptions, setAssumptions] = useState(null)
	const [loading, setLoading] = useState(false)
	const [showError, setShowError] = useState(false)
	const [errorMessage, setErrorMessage] = useState('')
	const [successMessage, setSuccessMessage] = useState('')
	const [showSuccess, setShowSuccess] = useState(false)
	const [propertyActuals, setPropertyActuals] = useState(null)
	const [NOIData, setNOIData ] = useState(DATA)
	const [showEditModal, setShowEditModal] = useState(false)
	const [editFieldDisplay, setEditFieldDisplay] = useState('')
	const [editFieldName, setEditFieldName] = useState('')
	const [editFieldValue, setEditFieldValue] = useState('')
	const [editFieldPercent, setEditFieldPercent] = useState('')
	const [manualValueChanged, setManualValueChanged] = useState(-1)
	const [mortgage, setMortgage] = useState('0')
	const [attomData, setAttomData] = useState(null)
	const [zillowData, setZillowData] = useState(null)
	const [manualLoanAmount, setManualLoanAmount] = useState(0) //manual per month loan amount
	const [loanFee, setLoanFee] = useState(0)
	const [loanFeeOption, setLoanFeeOption] = useState(null)

	const [grossIncomeActuals, setGrossIncomeActuals] = useState(0)
	const [grossIncomePro, setGrossIncomePro] = useState(0)
	const [grossIncomeMan, setGrossIncomeMan] = useState(0)
	const [totalExpensesActuals, setTotalExpensesActuals] = useState(0)
	const [totalExpensesPro, setTotalExpensesPro] = useState(0)
	const [totalExpensesMan, setTotalExpensesMan] = useState(0)
	const [totalExpPercent, setTotalExpPercent] = useState(0)
	const [totalExpPercentPro, setTotalExpPercentPro] = useState(0)
	const [totalExpPercentMan, setTotalExpPercentMan] = useState(0)
	const [NOIActuals, setNOIActuals] = useState(0)
	const [NOIPro, setNOIPro] = useState(0)
	const [NOIMan, setNOIMan] = useState(0)
	const [NOIActualsPercent, setNOIActualsPercent] = useState(0)
	const [NOIProPercent, setNOIProPercent] = useState(0)
	const [NOIManPercent, setNOIManPercent] = useState(0)
	const [NOIMarginActuals, setNOIMarginActuals] = useState(0)
	const [NOIMarginPro, setNOIMarginPro] = useState(0)
	const [NOIMarginMan, setNOIMarginMan] = useState(0)
	const [compSearchData, setCompSearchData] = useState({
		minComps: 1,
		maxComps: 10,
		miles: 5,
		bedroomsRange: 2,
		bathroomRange: 2,
		sqFeetRange: 600,
		lotSizeRange: 2000,
		saleDateRange: 6,
		yearBuiltRange: 10
	})
	const [rentalCompsSearchData, setRentalCompsSearchData] = useState({
		max_comps: 10,
		radius: 5,
		bedrooms_range: 2,
		bathrooms_range: 2,
		area_range: 600,
		year_range: 10,
		subject_year: 2000,
		subject_area: 1500,
		subject_bed: 3,
		subject_bath: 2,
		latitude: '',
		longitude: ''
	})


	const [loadingRentalComps, setLoadingRentalComps] = useState(false)
	const [loadingComps, setLoadingComps] = useState(false)
	const [attomCompsData, setAttomCompsData] = useState(null)
	const [zillowCompsData, setZillowCompsData] = useState(null)
	const [attomSubjectProperty, setAttomSubjectProperty] = useState(null)
	const [zillowRentalCompsData, setZillowRentalCompsData] = useState(null)
	const [zillowSubjectPropertyRent, setZillowSubjectPropertyRent] = useState(null)
	const [manualTableData, setManualTableData] = useState(null)
	const [showManualEntryModal, setShowManualEntryModal] = useState(false)
	const [manualModalString, setManualModalString] = useState('')
	const [manualModalSelectedValue, setManualModalSelectedValue] = useState(null)
	const [manualModalEntryPlaceholder, setManualModalEntryPlaceholder] = useState('')
	const [manualModalEntryValue, setManualModalEntryValue] = useState('')
	const [owners, setOwners]  = useState(null)
	const [showPhotos, setShowPhotos] = useState(false)

	useEffect(() => {
		if(!activeUnderwritingId) {
			navigate('/home/work-orders')
		}
	},[activeUnderwritingId])

	useEffect(() => {
		if(!NOIData) return null
		let {actuals, proforma, manual} = NOIData
		let grossIncomeActuals = Number(((actuals.rental_income.value+actuals.pet_income.value+actuals.other_income.value) - actuals.vacancy.value).toFixed(2))
		let grossIncomePro = Number(((proforma.rental_income.value+proforma.pet_income.value+proforma.other_income.value) - proforma.vacancy.value).toFixed(2))
		let grossIncomeMan = Number(((manual.rental_income.value+manual.pet_income.value+manual.other_income.value) - manual.vacancy.value).toFixed(2))
		setGrossIncomeActuals(grossIncomeActuals)
		setGrossIncomePro(grossIncomePro)
		setGrossIncomeMan(grossIncomeMan)

		let totalExpensesActuals = Number((actuals.property_taxes.value+actuals.management_fees.value+actuals.lease_fees.value+actuals.insurance.value+actuals.repairs_maintenance.value+actuals.cap_ex_reserve.value+actuals.other.value).toFixed(2))
		let totalExpensesPro = Number((proforma.property_taxes.value+proforma.management_fees.value+proforma.lease_fees.value+proforma.insurance.value+proforma.repairs_maintenance.value+proforma.cap_ex_reserve.value+proforma.other.value).toFixed(2))
		let totalExpensesMan = Number((manual.property_taxes.value+manual.management_fees.value+manual.lease_fees.value+manual.insurance.value+manual.repairs_maintenance.value+manual.cap_ex_reserve.value+manual.other.value).toFixed(2))
		setTotalExpensesActuals(totalExpensesActuals)
		setTotalExpensesPro(totalExpensesPro)
		setTotalExpensesMan(totalExpensesMan)

		setTotalExpPercent(actuals.rental_income.value === 0 ? 0 : Number(((totalExpensesActuals / actuals.rental_income.value) * 100).toFixed(2)))
		setTotalExpPercentPro(proforma.rental_income.value === 0 ? 0 : Number(((totalExpensesPro / proforma.rental_income.value) * 100).toFixed(2)))
		setTotalExpPercentMan(manual.rental_income.value === 0 ? 0 : Number(((totalExpensesMan / manual.rental_income.value) * 100).toFixed(2)))

		let NOIActuals = Number((grossIncomeActuals - totalExpensesActuals).toFixed(2))
		let NOIPro = Number((grossIncomePro - totalExpensesPro).toFixed(2))
		let NOIMan = Number((grossIncomeMan - totalExpensesMan).toFixed(2))
		setNOIActuals(NOIActuals)
		setNOIPro(NOIPro)
		setNOIMan(NOIMan)

		setNOIActualsPercent(actuals.rental_income.value === 0 ? 0 :NOIActuals / actuals.rental_income.value * 100)
		setNOIProPercent(proforma.rental_income.value === 0 ? 0 :NOIPro / proforma.rental_income.value * 100)
		setNOIManPercent(manual.rental_income.value === 0 ? 0 :NOIMan / manual.rental_income.value * 100)

		setNOIMarginActuals(actuals.rental_income.value === 0 ? 0 : Number(Number((NOIActuals/grossIncomeActuals)*100).toFixed(2)))
		setNOIMarginPro(proforma.rental_income.value === 0 ? 0 :Number(Number((NOIPro/grossIncomePro)*100).toFixed(2)))
		setNOIMarginMan(manual.rental_income.value === 0 ? 0 : Number(Number((NOIMan/grossIncomeMan)*100).toFixed(2)))

	}, [NOIData]);

	useEffect(() => {
		if(settingsState.status === API_CALL_STATUS.LOADING) {
			setLoading(true)
		} else if(settingsState.status === API_CALL_STATUS.FAILED) {
			setErrorMessage('Error when getting settings data. Please contact support if the problem persists.')
			setShowError(true)
		} else {
			setAssumptions(getAssumptionsSettings(settingsState))
			setLoading(false)

			if(settingsState.updated_settings) {
				setSuccessMessage('Settings updated successfully')
				setShowSuccess(true)
				dispatch(updateSettingsUpdatedStatus(false))
			}
		}
	},[settingsState])

	useEffect(() => {
		if(workOrdersState.status === API_CALL_STATUS.LOADING) {
			setLoading(true)
		} else if(workOrdersState.status === API_CALL_STATUS.FAILED) {
			setErrorMessage(`${workOrdersState.error}. Please contact support if the problem persists.`)
			setShowError(true)
		} else {
			setLoading(false)
			if(workOrdersState.updated_work_order_status) {
				setSuccessMessage('Successfully updated work order status')
				setShowSuccess(true)
				dispatch(updateWorkOrderStatusFlag(false))
			}
		}
	},[workOrdersState])

	useEffect(() => {
		if(assumptions && assumptions._id === 'assumptions' && assumptions.rates) {
			let {rates} = assumptions
			let tier1 = {
				c1: isNaN(rates['6']['benchmark']) || isNaN(rates['6']['spread']) ? '' : (Number(rates['6']['benchmark']) + Number(rates['6']['spread'])).toFixed(2),
				c2: isNaN(rates['9']['benchmark']) || isNaN(rates['9']['spread']) ? '' : (Number(rates['9']['benchmark']) + Number(rates['9']['spread'])).toFixed(2),
				c3: isNaN(rates['12']['benchmark']) || isNaN(rates['12']['spread']) ? '' : (Number(rates['12']['benchmark']) + Number(rates['12']['spread'])).toFixed(2),
				c4: isNaN(rates['18']['benchmark']) || isNaN(rates['18']['spread']) ? '' : (Number(rates['18']['benchmark']) + Number(rates['18']['spread'])).toFixed(2),
			}
			setManualTableData({
				"6": {amount: '', rate: Number(tier1.c1)},
				"9": {amount: '', rate: Number(tier1.c2)},
				"12": {amount: '', rate: Number(tier1.c3)},
        "18": {amount: '', rate: Number(tier1.c4)},
			})
		}
	}, [assumptions]);


	useEffect(() => {
		if(token && activeUnderwriting) {
			//get property actuals
			//get owner information
			if(activeUnderwritingId !== -1) {
				setLoading(true)
				//if coming from work orers page, get revela details
				getOwnerDetails(activeUnderwriting.property_id)
				.then(owners => {
					setOwners(owners)
				}).catch(err => {
					setErrorMessage(`Error when getting owner details - ${err.message}` )
					setShowError(true)
				})

				getPropertyActuals(activeUnderwriting.work_order_unit_id, activeUnderwriting.property_id)
				.then(data => {
					setLoading(false)
					setPropertyActuals(data)
				}).catch(err => {
					setLoading(false)
					LOGGER.error('Error when getting property actuals', err)
					setErrorMessage('Something went wrong when fetching property actuals or the property data does not exist')
					setShowError(true)
				})
			}


			if(activeUnderwriting?.property_address_line_one) {
				let {property_id, property_address_line_one, property_address_city, property_address_region, property_address_postal_code} = activeUnderwriting
				setAttomDataLoading(true)
				setAttomData(null)
				ApiHelpers.getAttomData(token, property_id, property_address_line_one, `${property_address_city} ${property_address_region} ${property_address_postal_code}`)
					.then(data => {
						console.log('attom data', data)
						setAttomData(data)
						setAttomDataLoading(false)
					})
					.catch(err => {
						LOGGER.error('Error when getting ATTOM data', err)
            setErrorMessage(err?.response?.data?.message || 'Error when fetching ATTOM data. Please check the address details and try again.')
            setShowError(true)
						setAttomDataLoading(false)
					})


				setZillowDataLoading(true)
				setZillowData(null)
				ApiHelpers.getZillowData(token, property_address_line_one,property_address_city, property_address_region, property_address_postal_code)
					.then(data => {
						console.log('got zillow data', data)
						if(data) {
							if(data.homeValuation) {
								let compsData = JSON.parse(data.homeValuation)
								if(compsData?.comparables?.comps?.length > 0) {
									let zillowData = compsData.comparables.comps
									setZillowCompsData(zillowData)
								}
							}
							setZillowData(data)
						} else {
							setErrorMessage(`Couldn't get zillow data. Please check the property details and try again.`)
							setShowError(true)
						}
						setZillowDataLoading(false)
					}).catch(err => {
						LOGGER.error('Error when getting Zillow data', err)
            setErrorMessage(err?.response?.data?.message || 'Error when getting Zillow data. Please check the property details and try again.')
            setShowError(true)
            setZillowDataLoading(false)
					})

			}


		}
	}, [token, activeUnderwriting, workOrdersState]);

	useEffect(() => {
		if(propertyActuals && assumptions && assumptions.financials) {
			console.log('property actuals are', propertyActuals)
			let {base_rent, total_rent, expenses, income} = propertyActuals
			let {vacancy_factor,
				property_taxes,
				management_fees,
				leasing_fees,
				property_insurance,
				repairs_maintenance,
				cap_ex_reserve,
				other
			} = assumptions.financials


			let actualRent = Number((income?.totalIncome).toFixed(2))
			let annualizedRent = Number((base_rent*12).toFixed(2))

			let otherIncome = Number((total_rent - base_rent).toFixed(2))
			let actualOtherIncome = 0.00
			let annualizedOtherIncome = Number((otherIncome*12).toFixed(2))


			let actuals = Object.assign({}, DATA.actuals, {
				rental_income: {value: actualRent, percent: 100},
				other_income: {value: actualOtherIncome, percent: actualRent > 0 ? Number(Number((actualOtherIncome/actualRent)*100).toFixed(2)): 0},
				other: {value: Number(Number(expenses?.totalExpense).toFixed(2)), percent: actualRent > 0 ? Number(((expenses?.totalExpense || 0)*100/actualRent).toFixed(2)) : 0},
			})

			let proforma = Object.assign({}, DATA.actuals, {
				rental_income: {value: annualizedRent, percent: 100},
				other_income: {value: annualizedOtherIncome, percent: Number(Number((annualizedOtherIncome/annualizedRent)*100).toFixed(2))},
				vacancy: {value: Number((vacancy_factor*annualizedRent/100).toFixed(2)), percent: Number(vacancy_factor.toFixed(2))},
				property_taxes: {value: Number((property_taxes*annualizedRent/100).toFixed(2)), percent: Number(property_taxes.toFixed(2))},
				management_fees: {value: Number((management_fees*annualizedRent/100).toFixed(2)), percent: Number(management_fees.toFixed(2))},
				lease_fees: {value: Number((leasing_fees*annualizedRent/100).toFixed(2)), percent: Number(leasing_fees.toFixed(2))},
				insurance: {value: Number((property_insurance*annualizedRent/100).toFixed(2)), percent: Number(property_insurance.toFixed(2))},
				repairs_maintenance: {value: Number((repairs_maintenance*annualizedRent/100).toFixed(2)), percent: Number(repairs_maintenance.toFixed(2))},
				cap_ex_reserve: {value: Number((cap_ex_reserve*annualizedRent/100).toFixed(2)), percent: Number(cap_ex_reserve.toFixed(2))},
				other: {value: Number((other*annualizedRent/100).toFixed(2)), percent: Number(other.toFixed(2))},
			})

			let manual = Object.assign({}, DATA.manual, {
				rental_income: {value: annualizedRent, percent: 100},
				other_income: {value: annualizedOtherIncome, percent: Number(Number((annualizedOtherIncome/annualizedRent)*100).toFixed(2))},
				vacancy: {value: Number((vacancy_factor*annualizedRent/100).toFixed(2)), percent: Number(vacancy_factor.toFixed(2))},
				property_taxes: {value: Number((property_taxes*annualizedRent/100).toFixed(2)), percent: Number(property_taxes.toFixed(2))},
				management_fees: {value: Number((management_fees*annualizedRent/100).toFixed(2)), percent: Number(management_fees.toFixed(2))},
				lease_fees: {value: Number((leasing_fees*annualizedRent/100).toFixed(2)), percent: Number(leasing_fees.toFixed(2))},
				insurance: {value: Number((property_insurance*annualizedRent/100).toFixed(2)), percent: Number(property_insurance.toFixed(2))},
				repairs_maintenance: {value: Number((repairs_maintenance*annualizedRent/100).toFixed(2)), percent: Number(repairs_maintenance.toFixed(2))},
				cap_ex_reserve: {value: Number((cap_ex_reserve*annualizedRent/100).toFixed(2)), percent: Number(cap_ex_reserve.toFixed(2))},
				other: {value: Number((other*annualizedRent/100).toFixed(2)), percent: Number(other.toFixed(2))},
			})

			setNOIData(Object.assign({}, DATA, {actuals, proforma, manual}))
		}
	}, [propertyActuals, assumptions]);

	useEffect(() => {
		let latitude = zillowData?.latitude || attomData?.location?.latitude || activeUnderwriting?.property_address_latitude
		let longitude = zillowData?.longitude || attomData?.location?.longitude || activeUnderwriting?.property_address_longitude
		let beds = zillowData?.bedrooms || attomData?.building?.rooms?.beds || activeUnderwriting?.property_bedrooms
		let baths = zillowData?.bathrooms || attomData?.building?.rooms?.bathstotal || activeUnderwriting?.property_bathrooms
		let area = zillowData?.livingAreaValue || attomData?.building?.size?.livingsize || activeUnderwriting?.property_square_feet
		let year = zillowData?.yearBuilt || attomData?.summary?.yearbuilt

		let temp = Object.assign({}, rentalCompsSearchData, {
			subject_year: year,
			subject_area: area,
			subject_bed: beds,
			subject_bath: baths,
			latitude: latitude,
			longitude: longitude
		})

		setRentalCompsSearchData(temp)


	}, [attomData, zillowData, activeUnderwriting]);

	useEffect(() => {
		if(zillowData) {
			let {zpid} = zillowData
			const config = {
				method: 'get',
				url: `${Config.BACKEND_URL}zillow/properties/${zpid}`,
				headers: {Authorization: token}
			}
			try {
				axios(config)
					.then((res) => {
						if(res.status === 200 && res.data){
							setZillowSubjectPropertyRent(res.data?.PRICE)
						}
					}).catch(err => {
						LOGGER.error('Error when getting property actuals', err)
					})

			} catch (err) {
				LOGGER.error('Error when getting zillow subjecct prop rental data', err)
			}
		}
	}, [zillowData]);

	const updateWorkOrderStatusClicked = (status) => {
		if(window.confirm(`Are you sure you want to change the status to ${status}?`)) {
			dispatch(updateWorkOrderStatus({token, workOrder: Object.assign({}, activeUnderwriting, {status: status})}))
		}

	}

	const getOwnerDetails = async (propertyId) => {
		return new Promise(async(resolve, reject) => {
			const config = {
				method: 'get',
				url: `${Config.BACKEND_URL}properties/owner-details?property_id=${propertyId}`,
				headers: {Authorization: token}
			}
			try {
				let res = await axios(config)
				console.log('got owner details', res.data)
				if(res.status === 200 && res.data) resolve(res.data)
				else reject('Missing owner details')
			} catch (err) {
				LOGGER.error('Error when getting owner details', err)
				reject(err)
			}
		})
	}


	const getPropertyActuals = async (unitId, propertyId) => {
		return new Promise(async(resolve, reject) => {
			const config = {
				method: 'get',
				url: `${Config.BACKEND_URL}properties/actuals?unit_id=${unitId}&property_id=${propertyId}`,
				headers: {Authorization: token}
			}
			try {
				let res = await axios(config)
				if(res.status === 200 && res.data) resolve(res.data)
				else reject('Missing actuals')
			} catch (err) {
				LOGGER.error('Error when getting property actuals', err)
				reject(err)
			}
		})
	}

	const onBackClicked = () => {
		dispatch(updateActiveUnderwriting(null))
		dispatch(updateActiveUnderwritingId(null))
		setAttomData(null)
		navigate('/home/work-orders')
	}

	const onManualRentalIncomeChanged = () => {
		let {manual} = NOIData
		let temp = Object.assign({}, manual)
		for(let key in manual) {
			if(key === 'rental_income')
				temp[key] = {value: Number(editFieldValue), percent: 100}
			else
				temp[key] = {value: Number(manual[key].value), percent: Number(Number(temp[key].value/editFieldValue*100).toFixed(2))}
		}

		setNOIData(Object.assign({}, NOIData, {manual: temp}))
		setShowEditModal(false)
	}

	const onEditConfirmClicked = () => {
		let {manual} = NOIData
		let temp = Object.assign({}, manual)
		if(manualValueChanged === 0) {
			//the actual value was edited. Calculate percentage from that
			temp[editFieldName] = {value: Number(editFieldValue), percent: Number(Number((editFieldValue/manual?.rental_income?.value)*100).toFixed(2))}
		} else {
			temp[editFieldName] = {value: Number((editFieldPercent*manual?.rental_income?.value/100).toFixed(2)), percent: Number(Number(editFieldPercent).toFixed(2))}
		}

		setNOIData(Object.assign({}, NOIData, {manual: temp}))
		setShowEditModal(false)
	}

	const searchRentalCompsClicked = async() => {
		if(!Helpers.checkIfNumber(zillowData?.latitude) || !Helpers.checkIfNumber(zillowData?.longitude)) {
			setErrorMessage('Cannot perform this search because the property latitude and longitude are missing')
			setShowError(true)
			return

		}

		let flag = false
		let temp = {}
		Object.keys(rentalCompsSearchData).every(key => {
			if(Helpers.isEmptyAndNaN(rentalCompsSearchData[key])) {
				flag = true
				return false
			}
			temp[key] = Number(rentalCompsSearchData[key])
			return true
		})

		if(flag) {
      setErrorMessage('Cannot perform this search because the search parameters are missing or contain non-numeric values')
      setShowError(true)
      return
    }

		setLoadingRentalComps(true)

		let headers =
			Object.assign({}, temp, {
					latitude: zillowData?.latitude,
					longitude: zillowData?.longitude,
					Authorization: token
				})

		const config = {
			method: 'get',
			url: `${Config.BACKEND_URL}zillow/rental-comps`,
			headers: headers,
		}

		try {
			let response = await axios(config)
			setZillowRentalCompsData(response.data)
			setLoadingRentalComps(false)
		}catch (err) {
			LOGGER.error('Error when getting rental comps', err)
      setLoadingRentalComps(false)
			setErrorMessage(err.response?.data?.message || 'Error when getting zillow rental comps')
			setShowError(true)
		}
	}

	const searchComparablesClicked = async() => {
		if(!attomData?.identifier?.attomId) {
			setErrorMessage('Cannot perform this search because the property ID is missing')
			setShowError(true)
			return
		}
		setLoadingComps(true)

		const config = {
			method: 'get',
			url: `${Config.BACKEND_URL}attom/sales-comps/${attomData?.identifier?.attomId}`,
			headers: {Authorization: token},
			params: compSearchData
		}
		try {
			let res = await axios(config)
			if(res.status === 200 && res.data) {
				let data = res.data?.RESPONSE_GROUP?.RESPONSE?.RESPONSE_DATA?.PROPERTY_INFORMATION_RESPONSE_ext?.SUBJECT_PROPERTY_ext?.PROPERTY || []
				if(data.length > 1) {
					//there are comparables to show
					let temp = []
					data.forEach((item, index) => {
						if(Object.keys(item).length > 2) {
							//this is the subject property, ignore it
							console.log('ignoring subject property', index, item)
							setAttomSubjectProperty(item)
						} else {
							temp.push(item.COMPARABLE_PROPERTY_ext)
						}
					})
					setAttomCompsData(temp)
					setLoadingComps(false)
				}



			}
		} catch (err) {
			LOGGER.error('Error when getting sales comparisons', err)
			setErrorMessage('Failed to retrieve comparable properties. Contact support if the problem persists.')
			setShowError(false)
			setLoadingComps(false)
		}
	}


	const renderBigCell = (string) => {
		return (
			<TableCell sx={{padding: '12px 10px 12px 10px', fontWeight: '800'}}>{string}</TableCell>
		)
	}

	const renderSmallCell = (string, onClick) => {
		return (
			<TableCell
				sx={{padding: '6px 10px 6px 10px', cursor: onClick ? 'pointer' : 'default', textDecoration: onClick? 'underline' : 'none'}}
				onClick={onClick}
			>
				{string}
			</TableCell>
		)
	}

	const renderSmallCellEditable = (string, onClick) => {
		return (
			<TableCell sx={{padding: '6px 10px 6px 10px'}}>
				<div style={{display: 'flex', flexDirection: 'row', position: 'relative', alignItems: 'center', width: '100%'}}>
					<p className={GeneralStyles.darkText}>{string}</p>
					<Edit style={{color: Colors.theme, position: 'absolute', right: 0, height: 20, width: 20, cursor: 'pointer'}} onClick={onClick}/>
				</div>
			</TableCell>
		)
	}

	const renderSmallCellEditable2 = (style, string, onClick) => {
		return (
			<TableCell sx={style}>
				<div style={{display: 'flex', flexDirection: 'row', position: 'relative', alignItems: 'center', width: '100%'}}>
					<p className={GeneralStyles.darkText}>{string}</p>
					<Edit style={{color: Colors.theme, position: 'absolute', right: 0, height: 20, width: 20, cursor: 'pointer'}} onClick={onClick}/>
				</div>
			</TableCell>
		)
	}

	const renderCompSearchFields = (label, placeholder, field, width=140) => {
		if(!compSearchData) return null
		return (
			<CustomTextFieldNew
				margin={8}
				width={width}
				label={label}
				placeholder={placeholder}
				value={compSearchData[field]}
				onChange={(text) => {
					if (Helpers.checkIfNumber(text)) {
						let temp = Object.assign({}, compSearchData)
						temp[field] = text.trim()
						setCompSearchData(temp)
					}
				}}
			/>
		)
	}

	const renderRentalCompsSearchFields = (label, placeholder, field, width=140) => {
		if(!rentalCompsSearchData) return null

		return (
			<CustomTextFieldNew
				margin={8}
				width={width}
				label={label}
				placeholder={placeholder}
				value={rentalCompsSearchData[field]}
				onChange={(text) => {
					if (Helpers.checkIfNumber(text)) {
						let temp = Object.assign({}, rentalCompsSearchData)
						temp[field] = text.trim()
						setRentalCompsSearchData(temp)
					}
				}}
			/>
		)
	}

	const getMedian = arr => {
		if(arr.length === 0) return 0;
		const mid = Math.floor(arr.length / 2),
			nums = [...arr].sort((a, b) => a - b);
		return arr.length % 2 !== 0 ? nums[mid] : (nums[mid - 1] + nums[mid]) / 2;
	};

	const renderZillowRentalCompsResult = () => {

		function getSubjectPropertyRent() {
			if(zillowSubjectPropertyRent?.PRICE)
				return Number(zillowSubjectPropertyRent?.PRICE)
      else if(zillowData?.rentZestimate && !isNaN(zillowData?.rentZestimate))
				return `$${Helpers.getFormattedNumber(Number(zillowData?.rentZestimate))} (Zillow Zestimate)`
			else if(attomData?.rentalAvm?.estimatedRentalValue && !isNaN(attomData?.rentalAvm?.estimatedRentalValue))
				return `$${Helpers.getFormattedNumber(Number(attomData?.rentalAvm?.estimatedRentalValue))} (ATTOM AVM)`
      else
				return 'N/A'
		}

		if(!zillowRentalCompsData) return null
		let rows = []
		let prices = []
		let pricePerSqFtArray = []
		let pricePerRoomArray = []
		let min = 1000000000000000
		let max = 0
		let mean = 0
		let median = 0
		let meanBeds = 0
		let totalBeds = 0
		let totalBaths = 0
		let meanBaths = 0
		let meanSquareFeet = 0
		let totalSquareFeet = 0
		let medianPricePerSqFt = 0
		let medianPricePerRoom = 0


		let subjectPropRent = getSubjectPropertyRent()
		let subjectPropBeds =  zillowData?.bedrooms ? Number(zillowData.bedrooms) : 'N/A'
		let subjectPropBaths = zillowData?.bathrooms ? Number(zillowData.bathrooms): 'N/A'
		let subjectPropSquareFeet = zillowData?.livingAreaValue ? Number(zillowData?.livingAreaValue) : 'N/A'
		let subjectPropPricePerSqFt = 'N/A'
		let subjectPropPricePerRoom = 'N/A'

		if(typeof subjectPropRent === 'number' && typeof subjectPropBeds === 'number') {
			subjectPropPricePerRoom = Number((subjectPropRent / subjectPropBeds).toFixed(2))
		}
		if(typeof subjectPropRent === 'number' && typeof subjectPropSquareFeet === 'number') {
			subjectPropPricePerSqFt = Number((subjectPropRent / subjectPropSquareFeet).toFixed(2))
		}

		zillowRentalCompsData?.forEach((item, index) => {
			let address = `${item.STREET_ADDRESS}, ${item.CITY}, ${item.STATE}, ${item.ZIPCODE}`
			let rent = item.PRICE && !isNaN(item.PRICE) ? Number(item.PRICE) : null
			let livingSqFt = item.LIVING_AREA && item.LIVING_AREA > 0 ? Number(item.LIVING_AREA) : null
			let perSqFtPrice =  livingSqFt && rent ? Number((rent / item.LIVING_AREA).toFixed(2)) : null

			if(typeof rent === 'number' && rent > 0) {
				if(rent > max) max = rent
				if(rent < min) min = rent
				mean += rent
				prices.push(rent)
				if(typeof livingSqFt === 'number' && livingSqFt > 0) {
					meanSquareFeet += livingSqFt
					totalSquareFeet++
				}
			}

			let beds = typeof item.BEDROOMS === 'number' && item.BEDROOMS > 0 ? Number(item.BEDROOMS) : null
			let baths = typeof item.BATHROOMS === 'number' && item.BATHROOMS > 0 ? Number(item.BATHROOMS) : null

			if(beds > 0) {
				meanBeds += beds
				totalBeds++
			}

			if(baths > 0) {
				meanBaths += baths
				totalBaths++
			}


			if(perSqFtPrice && perSqFtPrice > 0) {
				pricePerSqFtArray.push(perSqFtPrice)
			}

			let pricePerRoom = rent && beds && beds>0 ? Number((rent/beds).toFixed(2)) : null
			if(pricePerRoom && pricePerRoom > 0) {
				pricePerRoomArray.push(pricePerRoom)
			}

			rows.push(
				<div style={{width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'flex-start'}} key={address}>
					<p className={Styles.compEntry} style={{width: '24%'}}>{address}</p>
					<p className={Styles.compEntry} style={{width: '10%', marginLeft: 3}}>${rent ? Helpers.getFormattedNumber(rent.toFixed(2)) : '0.00'}</p>
					<p className={Styles.compEntry} style={{width: '10%', marginLeft: 3}}>${perSqFtPrice ? Helpers.getFormattedNumber(perSqFtPrice.toFixed(2)) : '0.00'}</p>
					<p className={Styles.compEntry} style={{width: '10%', marginLeft: 3}}>{livingSqFt ? `${Helpers.getFormattedNumber(livingSqFt)} sqft`  : 'N/A'} </p>
					<p className={Styles.compEntry} style={{width: '10%', marginLeft: 3}}>{item.LOT_AREA_VALUE?.length > 0 ? `${Helpers.getFormattedNumber(item.LOT_AREA_VALUE)} ${item.LOT_AREA_UNITS === "Square Feet" ? 'sqft' : item.LOT_AREA_UNITS}` : 'N/A'}</p>
					<p className={Styles.compEntry} style={{width: '8%', marginLeft: 3}}>{beds.toFixed(1)}</p>
					<p className={Styles.compEntry} style={{width: '8%', marginLeft: 3}}>{baths.toFixed(1)}</p>
					<p className={Styles.compEntry} style={{width: '6%', marginLeft: 3}}>{item.distanceInMiles && !isNaN(item.distanceInMiles) ? `${Number(item.distanceInMiles).toFixed(2)} mi` : 'N/A'}</p>
					<p className={Styles.compEntry} style={{width: '10%', marginLeft: 3}}>{item['HOME_TYPE']}</p>
					<p className={Styles.compEntry} style={{width: '6%', marginLeft: 3}}></p>
				</div>
			)
		})

		mean = mean / prices.length
		median = getMedian(prices)
		meanBeds = totalBeds > 0 ? meanBeds / totalBeds : 0
		meanBaths = totalBaths > 0 ? meanBaths / totalBaths : 0
		meanSquareFeet = meanSquareFeet / totalSquareFeet
		medianPricePerSqFt = getMedian(pricePerSqFtArray)
		medianPricePerRoom = getMedian(pricePerRoomArray)

		return (
			<div style={{width: '100%'}}>
				<div style={{width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center', marginTop: 20}}>
					{/*	sales comp table*/}

					<div style={{width: '60%', border: `1px solid ${Colors.tableLineColor}`, borderRadius: 10, padding: 10}}>
						<div className={Styles.salesCompsRow} style={{borderBottom: `1px solid ${Colors.tableLineColor}`}}>
							<label className={Styles.salesCompsLabel}></label>
							<p className={Styles.salesCompsValue} style={{fontWeight: 'bold'}}>ATTOM</p>
							<p className={Styles.salesCompsValue} style={{fontWeight: 'bold'}}>Subject</p>
						</div>
						<div className={Styles.salesCompsRow}>
							<label className={Styles.salesCompsLabel}>Min Rent</label>
							<p className={Styles.salesCompsValue}>${Helpers.getFormattedNumber(min.toFixed(2))}</p>
							<p className={Styles.salesCompsValue}>{subjectPropRent}</p>
						</div>
						<div className={Styles.salesCompsRow}>
							<label className={Styles.salesCompsLabel}>Median Rent</label>
							<p className={Styles.salesCompsValue}>${Helpers.getFormattedNumber(median.toFixed(2))}</p>
							<p className={Styles.salesCompsValue}></p>
						</div>
						<div className={Styles.salesCompsRow}>
							<label className={Styles.salesCompsLabel}>Mean Rent</label>
							<p className={Styles.salesCompsValue}>${Helpers.getFormattedNumber(mean.toFixed(2))}</p>
							<p className={Styles.salesCompsValue}></p>
						</div>
						<div className={Styles.salesCompsRow}>
							<label className={Styles.salesCompsLabel}>Max Rent</label>
							<p className={Styles.salesCompsValue}>${Helpers.getFormattedNumber(max.toFixed(2))}</p>
							<p className={Styles.salesCompsValue}></p>
						</div>
						<div className={Styles.salesCompsRow}>
							<label className={Styles.salesCompsLabel}>Median Rent/Room</label>
							<p className={Styles.salesCompsValue}>${Helpers.getFormattedNumber(medianPricePerRoom && Helpers.checkIfNumber(medianPricePerRoom) ? medianPricePerRoom.toFixed(2) : 0)}</p>
							<p className={Styles.salesCompsValue}>{typeof subjectPropPricePerRoom === 'number' ? `$${Helpers.getFormattedNumber(subjectPropPricePerRoom)}` : 'N/A'}</p>
						</div>
						<div className={Styles.salesCompsRow}>
							<label className={Styles.salesCompsLabel}>Median Rent/SQFT</label>
							<p className={Styles.salesCompsValue}>${Helpers.getFormattedNumber(medianPricePerSqFt && Helpers.checkIfNumber(medianPricePerSqFt) ? medianPricePerSqFt.toFixed(2) : 0)}</p>
							<p className={Styles.salesCompsValue}>{typeof subjectPropPricePerSqFt === 'number' ? `$${Helpers.getFormattedNumber(subjectPropPricePerSqFt)}` : 'N/A'}</p>
						</div>
						<div className={Styles.salesCompsRow}>
							<label className={Styles.salesCompsLabel}>Avg. Beds</label>
							<p className={Styles.salesCompsValue}>{meanBeds.toFixed(1)}</p>
							<p className={Styles.salesCompsValue}>{subjectPropBeds}</p>
						</div>
						<div className={Styles.salesCompsRow}>
							<label className={Styles.salesCompsLabel}>Avg. Baths</label>
							<p className={Styles.salesCompsValue}>{meanBaths.toFixed(1)}</p>
							<p className={Styles.salesCompsValue}>{subjectPropBaths}</p>
						</div>
						<div className={Styles.salesCompsRow}>
							<label className={Styles.salesCompsLabel}>Avg. SQFT</label>
							<p className={Styles.salesCompsValue}>{Helpers.getFormattedNumber(Number(meanSquareFeet.toFixed(2)))} sqft</p>
							<p className={Styles.salesCompsValue}>{Helpers.getFormattedNumber(subjectPropSquareFeet)} sqft</p>
						</div>
						{/*<div className={Styles.salesCompsRow}>*/}
						{/*	<label className={Styles.salesCompsLabel}>Median DOM</label>*/}
						{/*	<p className={Styles.salesCompsValue}></p>*/}
						{/*	<p className={Styles.salesCompsValue}></p>*/}
						{/*	<p className={Styles.salesCompsValue}></p>*/}
						{/*</div>*/}
					</div>

				</div>
				<p className={GeneralStyles.darkText} style={{width: '100%', textAlign: 'center', margin: 20, fontWeight: 'bold'}}>{`${rows.length || 0} Results `}</p>
				<div style={{width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center', borderBottom: `1px solid ${Colors.tableLineColor}`}}>
					<p className={Styles.compHeader} style={{width: '24%'}}>Address</p>
					<p className={Styles.compHeader} style={{width: '10%', marginLeft: 3}}>Rent</p>
					<p className={Styles.compHeader} style={{width: '10%', marginLeft: 3}}>Rent/sqft</p>
					<p className={Styles.compHeader} style={{width: '10%', marginLeft: 3}}>Gross Living Size</p>
					<p className={Styles.compHeader} style={{width: '10%', marginLeft: 3}}>Lot Sq Ft</p>
					<p className={Styles.compHeader} style={{width: '8%', marginLeft: 3}}>Bedroom(s)</p>
					<p className={Styles.compHeader} style={{width: '8%', marginLeft: 3}}>Bathrooms(s)</p>
					<p className={Styles.compHeader} style={{width: '6%', marginLeft: 3}}>Distance</p>
					<p className={Styles.compHeader} style={{width: '10%', marginLeft: 3}}>Type</p>
					<p className={Styles.compHeader} style={{width: '6%', marginLeft: 3}}>Pictures</p>
				</div>

				{rows}
			</div>
		)
	}

	const renderCompsResult = () => {

		if(!attomCompsData) return null

		let rows = []
		let prices = []
		let pricePerSqFtArray = []
		let pricePerRoomArray = []
		let min = 1000000000000000
		let max = 0
		let mean = 0
		let median = 0
		let meanBeds = 0
		let totalBeds = 0
		let totalBaths = 0
		let meanBaths = 0
		let meanSquareFeet = 0
		let totalSquareFeet = 0
		let medianPricePerSqFt = 0
		let medianPricePerRoom = 0


		let subjectPropSalesPrice = attomSubjectProperty?.SALES_HISTORY?.['@PropertySalesAmount'] ? Number(attomSubjectProperty?.SALES_HISTORY?.['@PropertySalesAmount']) : 'N/A'
		let subjectPropBeds = attomSubjectProperty?.STRUCTURE?.['@TotalBedroomCount'] ? Number(attomSubjectProperty?.STRUCTURE?.['@TotalBedroomCount']) : 'N/A'
		let subjectPropBaths = attomSubjectProperty?.STRUCTURE?.['@TotalBathroomCount'] ? Number(attomSubjectProperty?.STRUCTURE?.['@TotalBathroomCount']) : 'N/A'
		let subjectPropSquareFeet = attomSubjectProperty?.STRUCTURE?.['@GrossLivingAreaSquareFeetCount'] ? Number(attomSubjectProperty?.STRUCTURE?.['@GrossLivingAreaSquareFeetCount']) : 'N/A'
		let subjectPropPricePerSqFt = 'N/A'
		let subjectPropPricePerRoom = 'N/A'

		if(typeof subjectPropSalesPrice === 'number' && typeof subjectPropBeds === 'number') {
			subjectPropPricePerRoom = Number((subjectPropSalesPrice / subjectPropBeds).toFixed(2))
		}
		if(typeof subjectPropSalesPrice === 'number' && typeof subjectPropSquareFeet === 'number') {
      subjectPropPricePerSqFt = Number((subjectPropSalesPrice / subjectPropSquareFeet).toFixed(2))
    }

		attomCompsData?.forEach((item, index) => {
			let address = `${item['@_StreetAddress']}, ${item['@_City']}, ${item['@_State']}, ${item['@_PostalCode']}`
			let {SALES_HISTORY, STRUCTURE, SITE} = item
			let salePrice =
				SALES_HISTORY
				&& SALES_HISTORY['@PropertySalesAmount']
				&& Helpers.checkIfNumber(SALES_HISTORY['@PropertySalesAmount'])
				&& Number(SALES_HISTORY['@PropertySalesAmount']) !== 0.00
					? Number(SALES_HISTORY['@PropertySalesAmount']) : null

			let perSqFtPrice =
				SALES_HISTORY
				&& SALES_HISTORY['@PricePerSquareFootAmount']
				&& Helpers.checkIfNumber(SALES_HISTORY['@PricePerSquareFootAmount'])
				&& Number(SALES_HISTORY['@PricePerSquareFootAmount']) !== 0.00
					? Number(SALES_HISTORY['@PricePerSquareFootAmount']) : null

			if(typeof salePrice === 'number' && salePrice > 0) {
				if(Number(salePrice) > max) max = Number(salePrice)
				if(Number(salePrice) < min) min = Number(salePrice)
				mean += Number(salePrice)
				prices.push(Number(salePrice))
				let sqFt = Number(STRUCTURE['@GrossLivingAreaSquareFeetCount'])
				if(sqFt > 0) {
					meanSquareFeet += sqFt
					totalSquareFeet++
				}
			}

			let beds = Number(STRUCTURE['@TotalBedroomCount'])
			let baths = Number(STRUCTURE['@TotalBathroomCount'])

			if(beds > 0) {
				meanBeds += beds
				totalBeds++
			}

			if(baths > 0) {
				meanBaths += baths
				totalBaths++
			}


			if(perSqFtPrice && perSqFtPrice > 0) {
				pricePerSqFtArray.push(perSqFtPrice)
			}

			let distanceFromSubject = item['@DistanceFromSubjectPropertyMilesCount'] && Number(item['@DistanceFromSubjectPropertyMilesCount']) ? `${Number(item['@DistanceFromSubjectPropertyMilesCount']).toFixed(2)} mi` : 'N/A'
			let pricePerRoom = salePrice && beds && beds>0 ? Number((salePrice/beds).toFixed(2)) : null
			if(pricePerRoom && pricePerRoom > 0) {
				pricePerRoomArray.push(pricePerRoom)
			}

			rows.push(
				<div style={{width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'flex-start'}} key={address}>
					<p className={Styles.compEntry} style={{width: '20%'}}>{address}</p>
					<p className={Styles.compEntry} style={{width: '10%', marginLeft: 3}}>${salePrice ? Helpers.getFormattedNumber(salePrice.toFixed(2)) : '0.00'}</p>
					<p className={Styles.compEntry} style={{width: '8%', marginLeft: 3}}>${perSqFtPrice ? Helpers.getFormattedNumber(perSqFtPrice.toFixed(2)) : '0.00'}</p>
					<p className={Styles.compEntry} style={{width: '10%', marginLeft: 3}}>{SALES_HISTORY && SALES_HISTORY['@TransferDate_ext'] ? moment(SALES_HISTORY['@TransferDate_ext']).format('MMM Do YYYY') : 'N/A'}</p>
					<p className={Styles.compEntry} style={{width: '8%', marginLeft: 3}}>{Helpers.getFormattedNumber(Number(STRUCTURE['@GrossLivingAreaSquareFeetCount']))} sqft</p>
					<p className={Styles.compEntry} style={{width: '8%', marginLeft: 3}}>{Helpers.getFormattedNumber(Number(SITE['@LotSquareFeetCount']))} sqft</p>
					<p className={Styles.compEntry} style={{width: '6%', marginLeft: 3}}>{STRUCTURE['@StoriesCount']}</p>
					<p className={Styles.compEntry} style={{width: '8%', marginLeft: 3}}>{beds.toFixed(1)}</p>
					<p className={Styles.compEntry} style={{width: '8%', marginLeft: 3}}>{baths.toFixed(1)}</p>
					<p className={Styles.compEntry} style={{width: '6%', marginLeft: 3}}>{distanceFromSubject}</p>
					<p className={Styles.compEntry} style={{width: '10%', marginLeft: 3}}>{item['@StandardUseCode_ext']}</p>
				</div>
			)
		})

		mean = mean / prices.length
		median = getMedian(prices)
		meanBeds = totalBeds > 0 ? meanBeds / totalBeds : 0
		meanBaths = totalBaths > 0 ? meanBaths / totalBaths : 0
		meanSquareFeet = meanSquareFeet / totalSquareFeet
		medianPricePerSqFt = getMedian(pricePerSqFtArray)
		medianPricePerRoom = getMedian(pricePerRoomArray)

		return (
			<div style={{width: '100%'}}>
				<div style={{width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center', marginTop: 20}}>
				{/*	sales comp table*/}

					<div style={{width: '60%', border: `1px solid ${Colors.tableLineColor}`, borderRadius: 10, padding: 10}}>
						<div className={Styles.salesCompsRow} style={{borderBottom: `1px solid ${Colors.tableLineColor}`}}>
							<label className={Styles.salesCompsLabel}></label>
							<p className={Styles.salesCompsValue} style={{fontWeight: 'bold'}}>ATTOM</p>
							<p className={Styles.salesCompsValue} style={{fontWeight: 'bold'}}>Subject</p>
						</div>
						<div className={Styles.salesCompsRow}>
							<label className={Styles.salesCompsLabel}>Min Sale Price</label>
							<p className={Styles.salesCompsValue}>${Helpers.getFormattedNumber(min.toFixed(2))}</p>
							<p className={Styles.salesCompsValue}>${typeof subjectPropSalesPrice === 'number' ? Helpers.getFormattedNumber(subjectPropSalesPrice?.toFixed(2)) : '0.00'}</p>
						</div>
						<div className={Styles.salesCompsRow}>
							<label className={Styles.salesCompsLabel}>Median Sale Price</label>
							<p className={Styles.salesCompsValue}>${Helpers.getFormattedNumber(median.toFixed(2))}</p>
							<p className={Styles.salesCompsValue}></p>
						</div>
						<div className={Styles.salesCompsRow}>
							<label className={Styles.salesCompsLabel}>Mean Sale price</label>
							<p className={Styles.salesCompsValue}>${Helpers.getFormattedNumber(mean.toFixed(2))}</p>
							<p className={Styles.salesCompsValue}></p>
						</div>
						<div className={Styles.salesCompsRow}>
							<label className={Styles.salesCompsLabel}>Max Sale Price</label>
							<p className={Styles.salesCompsValue}>${Helpers.getFormattedNumber(max.toFixed(2))}</p>
							<p className={Styles.salesCompsValue}></p>
						</div>
						<div className={Styles.salesCompsRow}>
							<label className={Styles.salesCompsLabel}>Median Sale Price/Room</label>
							<p className={Styles.salesCompsValue}>${Helpers.getFormattedNumber(medianPricePerRoom && Helpers.checkIfNumber(medianPricePerRoom) ? medianPricePerRoom.toFixed(2) : 0)}</p>
							<p className={Styles.salesCompsValue}>{typeof subjectPropPricePerRoom === 'number' ? `$${Helpers.getFormattedNumber(subjectPropPricePerRoom)}` : 'N/A'}</p>
						</div>
						<div className={Styles.salesCompsRow}>
							<label className={Styles.salesCompsLabel}>Median Sale Price/SQFT</label>
							<p className={Styles.salesCompsValue}>${Helpers.getFormattedNumber(medianPricePerSqFt && Helpers.checkIfNumber(medianPricePerSqFt) ? medianPricePerSqFt.toFixed(2) : 0)}</p>
							<p className={Styles.salesCompsValue}>{typeof subjectPropPricePerSqFt === 'number' ? `$${Helpers.getFormattedNumber(subjectPropPricePerSqFt)}` : 'N/A'}</p>
						</div>
						<div className={Styles.salesCompsRow}>
							<label className={Styles.salesCompsLabel}>Avg. Beds</label>
							<p className={Styles.salesCompsValue}>{meanBeds.toFixed(1)}</p>
							<p className={Styles.salesCompsValue}>{subjectPropBeds}</p>
						</div>
						<div className={Styles.salesCompsRow}>
							<label className={Styles.salesCompsLabel}>Avg. Baths</label>
							<p className={Styles.salesCompsValue}>{meanBaths.toFixed(1)}</p>
							<p className={Styles.salesCompsValue}>{subjectPropBaths}</p>
						</div>
						<div className={Styles.salesCompsRow}>
							<label className={Styles.salesCompsLabel}>Avg. SQFT</label>
							<p className={Styles.salesCompsValue}>{Helpers.getFormattedNumber(Number(meanSquareFeet.toFixed(2)))} sqft</p>
							<p className={Styles.salesCompsValue}>{Helpers.getFormattedNumber(subjectPropSquareFeet)} sqft</p>
						</div>
						{/*<div className={Styles.salesCompsRow}>*/}
						{/*	<label className={Styles.salesCompsLabel}>Median DOM</label>*/}
						{/*	<p className={Styles.salesCompsValue}></p>*/}
						{/*	<p className={Styles.salesCompsValue}></p>*/}
						{/*	<p className={Styles.salesCompsValue}></p>*/}
						{/*</div>*/}
					</div>

				</div>
				<p className={GeneralStyles.darkText} style={{width: '100%', textAlign: 'center', margin: 20, fontWeight: 'bold'}}>{`${rows.length || 0} Results `}</p>
				<div style={{width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center', borderBottom: `1px solid ${Colors.tableLineColor}`}}>
					<p className={Styles.compHeader} style={{width: '20%'}}>Address</p>
					<p className={Styles.compHeader} style={{width: '10%', marginLeft: 3}}>Sale Amount</p>
					<p className={Styles.compHeader} style={{width: '8%', marginLeft: 3}}>Price/sqft</p>
					<p className={Styles.compHeader} style={{width: '10%', marginLeft: 3}}>Transfer Date</p>
					<p className={Styles.compHeader} style={{width: '8%', marginLeft: 3}}>Gross Living Size</p>
					<p className={Styles.compHeader} style={{width: '8%', marginLeft: 3}}>Lot Sq Ft</p>
					<p className={Styles.compHeader} style={{width: '6%', marginLeft: 3}}># Levels</p>
					<p className={Styles.compHeader} style={{width: '8%', marginLeft: 3}}>Bedroom(s)</p>
					<p className={Styles.compHeader} style={{width: '8%', marginLeft: 3}}>Bathrooms(s)</p>
					<p className={Styles.compHeader} style={{width: '6%', marginLeft: 3}}>Distance</p>
					<p className={Styles.compHeader} style={{width: '10%', marginLeft: 3}}>Type</p>
				</div>

				{rows}
			</div>
		)
	}

	const renderZillowSalesComps = () => {
		if(!zillowCompsData || zillowCompsData.length === 0)
			return <p className={GeneralStyles.darkText} style={{width: '100%', textAlign: 'center', margin: 20, fontWeight: 'bold'}}>No Zillow Sales Data Available</p>

		let rows = []
		let prices = []
		let pricePerSqFtArray = []
		let pricePerRoomArray = []
		let min = 1000000000000000
		let max = 0
		let mean = 0
		let median = 0
		let meanBeds = 0
		let totalBeds = 0
		let totalBaths = 0
		let meanBaths = 0
		let meanSquareFeet = 0
		let totalSquareFeet = 0
		let medianPricePerSqFt = 0
		let medianPricePerRoom = 0


		let subjectPropSalesPrice = zillowData?.lastSoldPrice ? Number(zillowData?.lastSoldPrice) : 'N/A'
		let subjectPropBeds =  zillowData?.bedrooms ? Number(zillowData.bedrooms) : 'N/A'
		let subjectPropBaths = zillowData?.bathrooms ? Number(zillowData.bathrooms): 'N/A'
		let subjectPropSquareFeet = zillowData?.livingAreaValue ? Number(zillowData?.livingAreaValue) : 'N/A'
		let subjectPropPricePerSqFt = 'N/A'
		let subjectPropPricePerRoom = 'N/A'

		if(typeof subjectPropSalesPrice === 'number' && typeof subjectPropBeds === 'number') {
			subjectPropPricePerRoom = Number((subjectPropSalesPrice / subjectPropBeds).toFixed(2))
		}
		if(typeof subjectPropSalesPrice === 'number' && typeof subjectPropSquareFeet === 'number') {
			subjectPropPricePerSqFt = Number((subjectPropSalesPrice / subjectPropSquareFeet).toFixed(2))
		}

		zillowCompsData?.forEach((data, index) => {
			let item = data.property
			if(!item) return
			let {city, state, zipcode, streetAddress} = item.address
			let address = `${streetAddress}, ${city}, ${state}, ${zipcode}`
			let salePrice = item?.lastSoldPrice ? Number(item.lastSoldPrice) : null
			let livingAreaValue = item?.livingAreaValue ? Number(item.livingAreaValue) : null

			let perSqFtPrice = livingAreaValue && livingAreaValue > 0 ? Number((salePrice / livingAreaValue).toFixed(2)) : null

			if(typeof salePrice === 'number' && salePrice > 0) {
				if(Number(salePrice) > max) max = Number(salePrice)
				if(Number(salePrice) < min) min = Number(salePrice)
				mean += Number(salePrice)
				prices.push(Number(salePrice))
				if(livingAreaValue > 0) {
					meanSquareFeet += livingAreaValue
					totalSquareFeet++
				}
			}

			let beds = Number(zillowData?.bedrooms || 0)
			let baths = Number(zillowData?.bathrooms || 0)

			if(beds > 0) {
				meanBeds += beds
				totalBeds++
			}

			if(baths > 0) {
				meanBaths += baths
				totalBaths++
			}


			if(perSqFtPrice && perSqFtPrice > 0) {
				pricePerSqFtArray.push(perSqFtPrice)
			}

			let distanceFromSubject = 'N/A'
			let pricePerRoom = salePrice && beds && beds>0 ? Number((salePrice/beds).toFixed(2)) : null
			if(pricePerRoom && pricePerRoom > 0) {
				pricePerRoomArray.push(pricePerRoom)
			}

			rows.push(
				<div style={{width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'flex-start'}} key={address}>
					<p className={Styles.compEntry} style={{width: '20%'}}>{address}</p>
					<p className={Styles.compEntry} style={{width: '10%', marginLeft: 3}}>${salePrice ? Helpers.getFormattedNumber(salePrice.toFixed(2)) : '0.00'}</p>
					<p className={Styles.compEntry} style={{width: '8%', marginLeft: 3}}>${perSqFtPrice ? Helpers.getFormattedNumber(perSqFtPrice.toFixed(2)) : '0.00'}</p>
					<p className={Styles.compEntry} style={{width: '10%', marginLeft: 3}}>{item?.dateSold ? moment(item.dateSold).format(DATE_FORMAT) : 'N/A'}</p>
					<p className={Styles.compEntry} style={{width: '8%', marginLeft: 3}}>{`${Helpers.getFormattedNumber(livingAreaValue)} ${item?.livingAreaUnitsShort}`}</p>
					<p className={Styles.compEntry} style={{width: '8%', marginLeft: 3}}>{item?.lotAreaValue ? `${Helpers.getFormattedNumber(Number(item.lotAreaValue.toFixed(2)))} ${item.lotAreaUnits}` : 'N/A'}</p>
					<p className={Styles.compEntry} style={{width: '6%', marginLeft: 3}}></p>
					<p className={Styles.compEntry} style={{width: '8%', marginLeft: 3}}>{beds.toFixed(1)}</p>
					<p className={Styles.compEntry} style={{width: '8%', marginLeft: 3}}>{baths.toFixed(1)}</p>
					<p className={Styles.compEntry} style={{width: '6%', marginLeft: 3}}>{distanceFromSubject}</p>
					<p className={Styles.compEntry} style={{width: '10%', marginLeft: 3}}>{item?.homeType}</p>
				</div>
			)
		})

		mean = mean / prices.length
		median = getMedian(prices)
		meanBeds = totalBeds > 0 ? meanBeds / totalBeds : 0
		meanBaths = totalBaths > 0 ? meanBaths / totalBaths : 0
		meanSquareFeet = meanSquareFeet / totalSquareFeet
		medianPricePerSqFt = getMedian(pricePerSqFtArray)
		medianPricePerRoom = getMedian(pricePerRoomArray)

		return (
			<div style={{width: '100%'}}>
				<div style={{width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center', marginTop: 20}}>
					{/*	sales comp table*/}

					<div style={{width: '60%', border: `1px solid ${Colors.tableLineColor}`, borderRadius: 10, padding: 10}}>
						<div className={Styles.salesCompsRow} style={{borderBottom: `1px solid ${Colors.tableLineColor}`}}>
							<label className={Styles.salesCompsLabel}></label>
							<p className={Styles.salesCompsValue} style={{fontWeight: 'bold'}}>Zillow</p>
							<p className={Styles.salesCompsValue} style={{fontWeight: 'bold'}}>Subject</p>
						</div>
						<div className={Styles.salesCompsRow}>
							<label className={Styles.salesCompsLabel}>Min Sale Price</label>
							<p className={Styles.salesCompsValue}>${Helpers.getFormattedNumber(min.toFixed(2))}</p>
							<p className={Styles.salesCompsValue}>{typeof subjectPropSalesPrice === 'number' ? `$${Helpers.getFormattedNumber(subjectPropSalesPrice.toFixed(2))}` : 'N/A'}</p>
						</div>
						<div className={Styles.salesCompsRow}>
							<label className={Styles.salesCompsLabel}>Median Sale Price</label>
							<p className={Styles.salesCompsValue}>${Helpers.getFormattedNumber(median.toFixed(2))}</p>
							<p className={Styles.salesCompsValue}></p>
						</div>
						<div className={Styles.salesCompsRow}>
							<label className={Styles.salesCompsLabel}>Mean Sale price</label>
							<p className={Styles.salesCompsValue}>${Helpers.getFormattedNumber(mean.toFixed(2))}</p>
							<p className={Styles.salesCompsValue}></p>
						</div>
						<div className={Styles.salesCompsRow}>
							<label className={Styles.salesCompsLabel}>Max Sale Price</label>
							<p className={Styles.salesCompsValue}>${Helpers.getFormattedNumber(max.toFixed(2))}</p>
							<p className={Styles.salesCompsValue}></p>
						</div>
						<div className={Styles.salesCompsRow}>
							<label className={Styles.salesCompsLabel}>Median Sale Price/Room</label>
							<p className={Styles.salesCompsValue}>${Helpers.getFormattedNumber(medianPricePerRoom && Helpers.checkIfNumber(medianPricePerRoom) ? medianPricePerRoom.toFixed(2) : 0)}</p>
							<p className={Styles.salesCompsValue}>{typeof subjectPropPricePerRoom === 'number' ? `$${Helpers.getFormattedNumber(subjectPropPricePerRoom)}` : 'N/A'}</p>
						</div>
						<div className={Styles.salesCompsRow}>
							<label className={Styles.salesCompsLabel}>Median Sale Price/SQFT</label>
							<p className={Styles.salesCompsValue}>${Helpers.getFormattedNumber(medianPricePerSqFt && Helpers.checkIfNumber(medianPricePerSqFt) ? medianPricePerSqFt.toFixed(2) : 0)}</p>
							<p className={Styles.salesCompsValue}>{typeof subjectPropPricePerSqFt === 'number' ? `$${Helpers.getFormattedNumber(subjectPropPricePerSqFt)}` : 'N/A'}</p>
						</div>
						<div className={Styles.salesCompsRow}>
							<label className={Styles.salesCompsLabel}>Avg. Beds</label>
							<p className={Styles.salesCompsValue}>{meanBeds.toFixed(1)}</p>
							<p className={Styles.salesCompsValue}>{subjectPropBeds}</p>
						</div>
						<div className={Styles.salesCompsRow}>
							<label className={Styles.salesCompsLabel}>Avg. Baths</label>
							<p className={Styles.salesCompsValue}>{meanBaths.toFixed(1)}</p>
							<p className={Styles.salesCompsValue}>{subjectPropBaths}</p>
						</div>
						<div className={Styles.salesCompsRow}>
							<label className={Styles.salesCompsLabel}>Avg. SQFT</label>
							<p className={Styles.salesCompsValue}>{Helpers.getFormattedNumber(Number(meanSquareFeet.toFixed(2)))} sqft</p>
							<p className={Styles.salesCompsValue}>{Helpers.getFormattedNumber(subjectPropSquareFeet)} sqft</p>
						</div>
						{/*<div className={Styles.salesCompsRow}>*/}
						{/*	<label className={Styles.salesCompsLabel}>Median DOM</label>*/}
						{/*	<p className={Styles.salesCompsValue}></p>*/}
						{/*	<p className={Styles.salesCompsValue}></p>*/}
						{/*	<p className={Styles.salesCompsValue}></p>*/}
						{/*</div>*/}
					</div>

				</div>
				<p className={GeneralStyles.darkText} style={{width: '100%', textAlign: 'center', margin: 20, fontWeight: 'bold'}}>{`${rows.length || 0} Results `}</p>
				<div style={{width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center', borderBottom: `1px solid ${Colors.tableLineColor}`}}>
					<p className={Styles.compHeader} style={{width: '20%'}}>Address</p>
					<p className={Styles.compHeader} style={{width: '10%', marginLeft: 3}}>Sale Amount</p>
					<p className={Styles.compHeader} style={{width: '8%', marginLeft: 3}}>Price/sqft</p>
					<p className={Styles.compHeader} style={{width: '10%', marginLeft: 3}}>Transfer Date</p>
					<p className={Styles.compHeader} style={{width: '8%', marginLeft: 3}}>Gross Living Size</p>
					<p className={Styles.compHeader} style={{width: '8%', marginLeft: 3}}>Lot Sq Ft</p>
					<p className={Styles.compHeader} style={{width: '6%', marginLeft: 3}}># Levels</p>
					<p className={Styles.compHeader} style={{width: '8%', marginLeft: 3}}>Bedroom(s)</p>
					<p className={Styles.compHeader} style={{width: '8%', marginLeft: 3}}>Bathrooms(s)</p>
					<p className={Styles.compHeader} style={{width: '6%', marginLeft: 3}}>Distance</p>
					<p className={Styles.compHeader} style={{width: '10%', marginLeft: 3}}>Type</p>
				</div>

				{rows}
			</div>
		)
	}

	const compareEqualValuesAndGetTextColor = (a, b) => {
		if(!a || !b || b.length === 0 || a.length   === 0 || isNaN(a) || isNaN(b)) return 'red'

		if(Number(a) === Number(b)) return Colors.primaryTextColor
		else return 'red'
	}

	const compareRelativeDiffAndGetTextColor = (a, b) => {
		function isDifferenceLessThanFivePercent(a, b) {
			const average = (a + b) / 2;
			const difference = Math.abs(a - b);
			return difference < 0.05 * average;
		}

		if(!a || !b || b.length === 0 || a.length   === 0 || isNaN(a) || isNaN(b)) return 'red'
		if(isDifferenceLessThanFivePercent(a, b)) return Colors.primaryTextColor
		else return 'red'
	}

	const renderAttomSalesComps = () => {

		return (
			<div style={{width: '100%', minHeight: 200}}>
				<div style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap'}}>
					{renderCompSearchFields('Radius Miles', 'radius', 'miles')}
					{renderCompSearchFields('Bedrooms Range', 'bedrooms', 'bedroomsRange')}
					{renderCompSearchFields('Bathrooms Range', 'bathrooms', 'bathroomRange')}
					{renderCompSearchFields('Living Area Range', 'living area range', 'sqFeetRange', 200)}
					{renderCompSearchFields('Lot Size Range', 'lot size range', 'lotSizeRange', 200)}
					{renderCompSearchFields('Year Built Range', 'year built range', 'yearBuiltRange', 200)}
					{renderCompSearchFields('Sale Date Range', 'sale date range', 'saleDateRange', 200)}
					{renderCompSearchFields('Min # Comps', 'min # comps', 'minComps')}
					{renderCompSearchFields('Max # Comps', 'max # comps', 'maxComps')}
				</div>
				<div style={{width: '98%', display: "flex", flexDirection: 'row', justifyContent: 'flex-end', marginTop: 20}}>
					<CustomButtonContained
						text={'Search Sales Comps'}
						onClick={searchComparablesClicked}
						style={{}}
						color={'primary'}
					/>
				</div>

				{
					loadingComps?
            <CustomLoaderSpinner />
            :
						attomCompsData?.length > 0 ?
							renderCompsResult()
							:
							<p className={GeneralStyles.darkText} style={{marginTop: 40, width: '100%', textAlign: 'center'}}>Nothing to display</p>
				}
			</div>
		)
	}

	const renderAttomAndZillowData = () => {
		if(attomDataLoading || zillowDataLoading)
			return (
				<div style={{ height: '20vh', display: 'flex', alignItems: 'center', width: '100%', flexDirection: 'row'}}>
					<CustomLoaderSpinner />
				</div>
			)

		let owner = attomData?.owner || {}
		let owners = (owner.owner1?.fullname ? owner.owner1.fullname : '')
										+ (owner?.owner2?.fullname ? ', '+owner.owner2.fullname : '')
										+ (owner?.owner3?.fullname ? ', '+owner.owner3.fullname : '')
										+ (owner?.owner4?.fullname ? ', '+owner.owner4.fullname : '')
		let sale = attomData?.sale || {}
		let mortgage = attomData?.mortgage || {}
		let rentalAvm = attomData?.rentalAvm || {}
		let salesAvm = attomData?.avm || {}
		let building = attomData?.building || {}

		//zillow data
		let propertyDetails = zillowData?.property || []
		let zillowLevels = 'N/A'
		propertyDetails.forEach(details => {
			if(details['title'] === 'Features') {
				let values = details['values'] || []
				values.forEach(value => {
					if(value.includes('Levels')) {
            zillowLevels = value.split(':')[1].trim()
          }
				})
			}
		})

		if(zillowLevels !== 'N/A') {
			//convert one, two to 1,2 etc
			switch(zillowLevels.toLowerCase()) {
				case 'one': zillowLevels = '1'; break;
				case 'two': zillowLevels = '2'; break;
				case 'three': zillowLevels = '3'; break;
				case 'four': zillowLevels = '4'; break;
				default:
			}
		}

		let taxHistory = zillowData?.taxHistory || []
		taxHistory.sort((a,b) => b.time-a.time)
		let taxAmount = ''
		let taxYear = ''
		taxHistory.every(item => {
			if(typeof item.taxPaid === 'number') {
				taxAmount = item.taxPaid.toFixed(2)
        taxYear = moment(item.time).format('YYYY')
				return false
			}
			return true
		})

		return (
			<div style={{width: '100%', border: `1px solid ${Colors.tableLineColor}`, borderRadius: 10, padding: '10px 0px'}}>
				<div style={{width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
					<div style={{width: '48%', padding: '0px 8px'}}>
						<div className={Styles.row} style={{marginBottom: 10}}>
							<p className={Styles.labelText}></p>
							<p className={Styles.entryText3} style={{fontWeight: 'bold'}}>ATTOM</p>
							<p className={Styles.entryText3} style={{marginLeft: '2%', fontWeight: 'bold'}}>Zillow</p>
						</div>
						<div className={Styles.row}>
							<p className={Styles.labelText}>Year Built</p>
							<p className={Styles.entryText3} style={{color: compareEqualValuesAndGetTextColor(attomData?.summary?.yearbuilt, zillowData?.yearBuilt)}}>{attomData?.summary?.yearbuilt}</p>
							<p className={Styles.entryText3} style={{marginLeft: '2%', color: compareEqualValuesAndGetTextColor(attomData?.summary?.yearbuilt, zillowData?.yearBuilt)}}>{zillowData?.yearBuilt}</p>
						</div>
						<div className={Styles.row}>
							<p className={Styles.labelText}>Property Condition</p>
							<p className={Styles.entryText3}>{attomData?.building?.construction?.condition}</p>
							<p className={Styles.entryText3} style={{marginLeft: '2%'}}></p>
						</div>
						<div className={Styles.row}>
							<p className={Styles.labelText}>Property Levels</p>
							<p className={Styles.entryText3} style={{color: compareEqualValuesAndGetTextColor(attomData?.building?.summary?.levels, zillowLevels)}}>{attomData?.building?.summary?.levels}</p>
							<p className={Styles.entryText3} style={{marginLeft: '2%', color: compareEqualValuesAndGetTextColor(attomData?.building?.summary?.levels, zillowLevels)}}>{zillowLevels}</p>
						</div>

						<div className={Styles.row}>
							<p className={Styles.labelText}>Bedrooms</p>
							<p className={Styles.entryText3} style={{color: compareEqualValuesAndGetTextColor(building?.rooms?.beds, zillowData?.bedrooms)}}>{`${building?.rooms?.beds || ''}`}</p>
							<p className={Styles.entryText3} style={{marginLeft: '2%', color: compareEqualValuesAndGetTextColor(building?.rooms?.beds, zillowData?.bedrooms)}}>{zillowData?.bedrooms}</p>
						</div>
						<div className={Styles.row}>
							<p className={Styles.labelText}>Bathrooms</p>
							<p className={Styles.entryText3} style={{color: compareEqualValuesAndGetTextColor(building?.rooms?.bathstotal, zillowData?.bathrooms)}}>{`${building?.rooms?.bathstotal || ''}`}</p>
							<p className={Styles.entryText3} style={{marginLeft: '2%',color: compareEqualValuesAndGetTextColor(building?.rooms?.bathstotal, zillowData?.bathrooms) }}>{zillowData?.bathrooms}</p>
						</div>
						<div className={Styles.row}>
							<p className={Styles.labelText}>Building Area</p>
							<p className={Styles.entryText3}>{`${building?.size?.universalsize || ''} ${building?.size?.sizeInd || ''}`}</p>
							<p className={Styles.entryText3} style={{marginLeft: '2%'}}></p>
						</div>
						<div className={Styles.row}>
							<p className={Styles.labelText}>Gross Area</p>
							<p className={Styles.entryText3}>{`${building?.size?.grosssizeadjusted || ''} ${building?.size?.sizeInd || ''}`}</p>
							<p className={Styles.entryText3} style={{marginLeft: '2%'}}></p>
						</div>
						<div className={Styles.row}>
							<p className={Styles.labelText}>Living Area</p>
							<p className={Styles.entryText3} style={{color: compareEqualValuesAndGetTextColor(building?.size?.livingsize, zillowData?.livingAreaValue)}}>{`${building?.size?.livingsize || ''} ${building?.size?.sizeInd || ''}`}</p>
							<p className={Styles.entryText3} style={{marginLeft: '2%', color: compareEqualValuesAndGetTextColor(building?.size?.livingsize, zillowData?.livingAreaValue)}}>{zillowData?.livingAreaValue ? `${zillowData.livingAreaValue} ${zillowData.livingAreaUnitsShort}` : ''}</p>
						</div>

						<div className={Styles.row}>
							<p className={Styles.labelText}>Owner(s)</p>
							<p className={Styles.entryText3}>{owners ? owners : ''}</p>
							<p className={Styles.entryText3} style={{marginLeft: '2%'}}></p>
						</div>
						<div className={Styles.row}>
							<p className={Styles.labelText}>Mailing Address</p>
							<p className={Styles.entryText3}>{owner?.mailingaddressoneline}</p>
							<p className={Styles.entryText3} style={{marginLeft: '2%'}}></p>
						</div>
						<div className={Styles.row}>
							<p className={Styles.labelText}>Sale Details</p>
							<p className={Styles.entryText3} style={{color: compareEqualValuesAndGetTextColor(sale?.amount?.saleamt, zillowData?.lastSoldPrice)}}>{sale && sale.amount ? `$${Helpers.getFormattedNumber(sale.amount.saleamt || 0)} on ${moment(sale.amount.salerecdate).format(DATE_FORMAT)}` : ''}</p>
							<p className={Styles.entryText3} style={{marginLeft: '2%', color: compareEqualValuesAndGetTextColor(sale?.amount?.saleamt, zillowData?.lastSoldPrice)}}>{zillowData?.lastSoldPrice ? `$${Helpers.getFormattedNumber(Number(zillowData.lastSoldPrice))} on ${moment(zillowData.dateSold).format(DATE_FORMAT)}` : ''}</p>
						</div>
						<div className={Styles.row}>
							<p className={Styles.labelText}>Property Tax Rate</p>
							<p className={Styles.entryText3}></p>
							<p className={Styles.entryText3} style={{marginLeft: '2%'}}>{zillowData?.propertyTaxRate ? `${zillowData.propertyTaxRate}%` : ''}</p>
						</div>
						<div className={Styles.row}>
							<p className={Styles.labelText}>Last Tax Amount</p>
							<p className={Styles.entryText3} style={{color: compareEqualValuesAndGetTextColor(attomData?.assessment?.tax?.taxamt, taxAmount)}}>{attomData?.assessment?.tax ? `$${Helpers.getFormattedNumber(attomData.assessment.tax?.taxamt || 0)}(${attomData.assessment.tax?.taxyear})` : ''}</p>
							<p className={Styles.entryText3} style={{marginLeft: '2%', color: compareEqualValuesAndGetTextColor(attomData?.assessment?.tax?.taxamt, taxAmount)}}>{taxAmount !== '' ? `$${Helpers.getFormattedNumber(taxAmount || 0)}(${taxYear})` : ''}</p>
						</div>
						<div className={Styles.row}>
							<p className={Styles.labelText}>Assessed Value</p>
							<p className={Styles.entryText3} style={{color: compareEqualValuesAndGetTextColor(attomData?.assessment?.assessed?.assdttlvalue, zillowData?.taxAssessedValue)}}>{attomData?.assessment?.assessed ? `$${Helpers.getFormattedNumber(attomData.assessment.assessed?.assdttlvalue || 0)}` : ''}</p>
							<p className={Styles.entryText3} style={{marginLeft: '2%', color: compareEqualValuesAndGetTextColor(attomData?.assessment?.assessed?.assdttlvalue, zillowData?.taxAssessedValue)}}>{zillowData?.taxAssessedValue ? `$${Helpers.getFormattedNumber(zillowData.taxAssessedValue)}(${zillowData.taxAssessedYear})` : ''}</p>
						</div>
						<div className={Styles.row}>
							<p className={Styles.labelText}>Mortgage Amount</p>
							<p className={Styles.entryText3}>{mortgage?.amount ? `${Helpers.getFormattedNumber(mortgage?.amount || 0)}`: ''}</p>
							<p className={Styles.entryText3} style={{marginLeft: '2%'}}></p>
						</div>
						<div className={Styles.row}>
							<p className={Styles.labelText}>Term</p>
							<p className={Styles.entryText3}>{mortgage?.term ? `${mortgage.term}`: ''}</p>
							<p className={Styles.entryText3} style={{marginLeft: '2%'}}></p>
						</div>
						<div className={Styles.row}>
							<p className={Styles.labelText}>Start & End</p>
							<p className={Styles.entryText3}>{mortgage?.amount ? `${moment(mortgage.date).format(DATE_FORMAT)} & ${moment(mortgage.duedate).format(DATE_FORMAT)}` : ''}</p>
							<p className={Styles.entryText3} style={{marginLeft: '2%'}}></p>
						</div>

						<div className={Styles.row}>
							<p className={Styles.labelText}>Photos</p>
							<p className={Styles.entryText3}></p>
							<p
								className={Styles.entryText3}
								style={{marginLeft: '2%', cursor: 'pointer', textDecoration: 'underline'}}
								onClick={() => {
									if(zillowData?.photoCount > 0) {
										setShowPhotos(true)
									} else {
										setErrorMessage('No photos available for this property')
										setShowError(true)
									}
								}}
							>
								{zillowData?.photoCount} Photo(s)
							</p>
						</div>

						<div className={Styles.row} style={{width: '100%'}}>
							<Accordion
								TransitionProps={{
									timeout: 200, // Set transition time to 500ms
								}}
								sx={{boxShadow: '0px 4px 15px 0px #00000066', border: '1px solid #E7E7E7', marginTop: 2, width: '100%'}}
								expanded={mortgageExpanded}
								onChange={() => setMortgageExpanded(!mortgageExpanded)}>
								<AccordionSummary
									expandIcon={<ExpandMoreIcon style={{color: Colors.primaryTextColor}}/>}
									aria-controls="mortage_estimate"
									id="mortgage_estimate"
									sx={{height: 40}}
								>
									<p className={GeneralStyles.darkText} style={{fontWeight: 'bold'}}>Mortage Estimate</p>
								</AccordionSummary>
								<AccordionDetails>
									<div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%'}}>
										<MortgageEstimate mortgageAmount={mortgage?.amount} date={mortgage.date ? moment(mortgage.date).toDate() : new Date()} loanTerm={mortgage?.term || 0}/>
									</div>
								</AccordionDetails>
							</Accordion>
						</div>

					</div>

					<div style={{borderRight: `1px solid ${Colors.tableLineColor}`}}/>

					<div style={{width: '48%', padding: '0px 8px'}}>
						<p style={{width: '100%', textAlign: 'center', fontSize: CONSTANTS.headerSize, fontWeight: 'bold', color: Colors.primaryTextColor}}>Rental AVM</p>
						<div className={Styles.row} style={{marginBottom: 10}}>
							<p className={Styles.labelText2}></p>
							<p className={Styles.entryText3} style={{fontWeight: 'bold'}}>ATTOM</p>
							<p className={Styles.entryText3} style={{marginLeft: '2%', fontWeight: 'bold'}}>Zillow</p>
						</div>
						<div className={Styles.row}>
							<p className={Styles.labelText2}>Estimated Date</p>
							<p className={Styles.entryText3}>{rentalAvm?.valuationDate}</p>
							<p className={Styles.entryText3} style={{marginLeft: '2%'}}></p>
						</div>
						<div className={Styles.row}>
							<p className={Styles.labelText2}>Rental Value(Monthly)</p>
							<p className={Styles.entryText3} style={{color: compareRelativeDiffAndGetTextColor(rentalAvm?.estimatedRentalValue, zillowData?.rentZestimate)}}>${Helpers.getFormattedNumber(rentalAvm?.estimatedRentalValue || 0)}</p>
							<p className={Styles.entryText3} style={{marginLeft: '2%', color: compareRelativeDiffAndGetTextColor(rentalAvm?.estimatedRentalValue, zillowData?.rentZestimate)}}>${Helpers.getFormattedNumber(zillowData?.rentZestimate || 0)}</p>
						</div>
						<div className={Styles.row}>
							<p className={Styles.labelText2}>Rental Value(Annualized)</p>
							<p className={Styles.entryText3} style={{color: compareRelativeDiffAndGetTextColor(rentalAvm?.estimatedRentalValue, zillowData?.rentZestimate)}}>${rentalAvm?.estimatedRentalValue ? `${Helpers.getFormattedNumber(rentalAvm?.estimatedRentalValue*12 || 0)}` : 0}</p>
							<p className={Styles.entryText3} style={{marginLeft: '2%', color: compareRelativeDiffAndGetTextColor(rentalAvm?.estimatedRentalValue, zillowData?.rentZestimate)}}>${zillowData?.rentZestimate ? `${Helpers.getFormattedNumber(zillowData?.rentZestimate*12 || 0)}` : 0}</p>
						</div>
						<div className={Styles.row}>
							<p className={Styles.labelText2}>Min Rental Value(Monthly)</p>
							<p className={Styles.entryText3}>${Helpers.getFormattedNumber(rentalAvm?.estimatedMinRentalValue || 0)}</p>
							<p className={Styles.entryText3} style={{marginLeft: '2%'}}></p>
						</div>
						<div className={Styles.row}>
							<p className={Styles.labelText2}>Min Rental Value(Annualized)</p>
							<p className={Styles.entryText3}>${Helpers.getFormattedNumber(rentalAvm?.estimatedMinRentalValue*12 || 0)}</p>
							<p className={Styles.entryText3} style={{marginLeft: '2%'}}></p>
						</div>
						<div className={Styles.row}>
							<p className={Styles.labelText2}>Max Rental Value(Monthly)</p>
							<p className={Styles.entryText3}>${Helpers.getFormattedNumber(rentalAvm?.estimatedMaxRentalValue || 0)}</p>
							<p className={Styles.entryText3} style={{marginLeft: '2%'}}></p>
						</div>
						<div className={Styles.row}>
							<p className={Styles.labelText2}>Max Rental Value(Annualized)</p>
							<p className={Styles.entryText3}>${Helpers.getFormattedNumber(rentalAvm?.estimatedMaxRentalValue*12 || 0)}</p>
							<p className={Styles.entryText3} style={{marginLeft: '2%'}}></p>
						</div>

						<div style={{width: '100%', borderBottom: `1px solid ${Colors.tableLineColor}`, marginTop: 10, marginBottom: 10}}/>
						<p style={{width: '100%', textAlign: 'center', fontSize: CONSTANTS.headerSize, fontWeight: 'bold', color: Colors.primaryTextColor}}>Sales AVM</p>
						<div className={Styles.row}>
							<p className={Styles.labelText2}>Estimated Date</p>
							<p className={Styles.entryText3}>{salesAvm?.eventDate}</p>
							<p className={Styles.entryText3} style={{marginLeft: '2%'}}></p>
						</div>
						<div className={Styles.row}>
							<p className={Styles.labelText2}>Sale Value</p>
							<p className={Styles.entryText3} style={{color: compareRelativeDiffAndGetTextColor(salesAvm?.amount?.value, zillowData?.zestimate)}}>${Helpers.getFormattedNumber(salesAvm?.amount?.value || 0)}</p>
							<p className={Styles.entryText3} style={{marginLeft: '2%', color: compareRelativeDiffAndGetTextColor(salesAvm?.amount?.value, zillowData?.zestimate)}}>${Helpers.getFormattedNumber(zillowData?.zestimate || 0)}</p>
						</div>
						<div className={Styles.row}>
							<p className={Styles.labelText2}>Min Sale Value</p>
							<p className={Styles.entryText3}>${Helpers.getFormattedNumber(salesAvm?.amount?.low || 0)}</p>
							<p className={Styles.entryText3} style={{marginLeft: '2%'}}></p>
						</div>
						<div className={Styles.row}>
							<p className={Styles.labelText2}>Max Sale Value</p>
							<p className={Styles.entryText3}>${Helpers.getFormattedNumber(salesAvm?.amount?.high || 0)}</p>
							<p className={Styles.entryText3} style={{marginLeft: '2%'}}></p>
						</div>
					</div>
				</div>
			</div>
		)
	}

	const renderNOIMarginDetails = () => {
		if(!assumptions) return null

		let {actuals, proforma, manual} = NOIData
		let dscr_tiers = assumptions?.underwriting?.dscr_tiers || []

		let startDate = propertyActuals?.start_date ? moment(propertyActuals.start_date) : 'N/A'
		let endDate = propertyActuals?.end_date ? moment(propertyActuals.end_date) : 'N/A'



		return (
			<div style={{width: '100%', flexDirection: 'row', display: 'flex', justifyContent: 'center'}}>
				<div style={{width: '90%'}}>
					<Table sx={{ width: '100%'}} aria-label="simple table">
						<TableHead>
							<TableRow>
								<TableCell sx={{padding: '10px', width: '28%'}}></TableCell>
								<TableCell sx={{padding: '10px', width: '24%'}}>
									<div style={{display: 'flex', flexDirection: 'column'}}>
										<label style={{fontWeight: 'bold', color: 'black', fontSize: 14}}>
											Actuals
										</label>
										<label style={{fontWeight: 'bold', color: 'black', fontSize: 12}}>
											{`(${moment().subtract(1, 'years').format(DATE_FORMAT)} - ${moment().format(DATE_FORMAT)})`}
										</label>
									</div>
								</TableCell>
								<TableCell sx={{padding: '10px', width: '24%'}}>
									<div style={{display: 'flex', flexDirection: 'column'}}>
										<label style={{fontWeight: 'bold', color: 'black', fontSize: 14}}>
											Proforma
										</label>
										<label style={{fontWeight: 'bold', color: 'black', fontSize: 12}}>
											{`(Annualized: Base Rent $${Helpers.getFormattedNumber(propertyActuals?.base_rent || 0)})`}
										</label>
										<label style={{color: 'black', fontSize: 12}}>
											{`(Lease ${moment(startDate).format(DATE_FORMAT)} - ${moment(endDate).format(DATE_FORMAT)})`}
										</label>
									</div>
								</TableCell>
								<TableCell sx={{padding: '10px', width: '24%'}}><label style={{fontWeight: 'bold', color: 'black', fontSize: 14}}>Manual</label></TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							<TableRow key={5}>
								<TableCell component="th" scope="row" sx={{padding: '12px 10px 12px 10px', fontWeight: '800'}}>Gross Income</TableCell>
								{renderBigCell(`$${Helpers.getFormattedNumber(grossIncomeActuals)}`)}
								{renderBigCell(`$${Helpers.getFormattedNumber(grossIncomePro)}`)}
								{renderBigCell(`$${Helpers.getFormattedNumber(grossIncomeMan)}`)}
							</TableRow>
							<TableRow key={1}>
								<TableCell component="th" scope="row" sx={{padding: '6px 10px 6px 10px'}}>Rental Income</TableCell>
								{renderSmallCell(
									`$${Helpers.getFormattedNumber(actuals?.rental_income?.value || 0)} (${actuals?.rental_income?.percent.toFixed(2) || 0}%)`,
									() => setShowIncomeModal(true)
								)}
								{renderSmallCell(`$${Helpers.getFormattedNumber(proforma?.rental_income?.value || 0)} (${proforma?.rental_income?.percent.toFixed(2) || 0}%)`)}
								{renderSmallCellEditable(
									`$${Helpers.getFormattedNumber(manual?.rental_income?.value || 0)} (${manual?.rental_income?.percent.toFixed(2) || 0}%)`,
									() => {
										setEditFieldDisplay("Rental Income")
										setEditFieldName("rental_income")
										setEditFieldValue(manual?.rental_income?.value || 0)
										setEditFieldPercent(manual?.rental_income?.percent.toFixed(2) || 0)
										setShowEditModal(true)
									}
								)}
							</TableRow>
							<TableRow key={2}>
								<TableCell component="th" scope="row" sx={{padding: '6px 10px 6px 10px'}}>Pet Income</TableCell>
								{renderSmallCell(`$${Helpers.getFormattedNumber(actuals?.pet_income?.value || 0)} (${actuals?.pet_income?.percent.toFixed(2) || 0}%)`)}
								{renderSmallCell(`$${Helpers.getFormattedNumber(proforma?.pet_income?.value || 0)} (${proforma?.pet_income?.percent.toFixed(2) || 0}%)`)}
								{renderSmallCellEditable(
									`$${Helpers.getFormattedNumber(manual?.pet_income?.value || 0)} (${manual?.pet_income?.percent.toFixed(2) || 0}%)`,
									() => {
										setEditFieldDisplay("Pet Income")
										setEditFieldName("pet_income")
										setEditFieldValue(manual?.pet_income?.value || 0)
										setEditFieldPercent(manual?.pet_income?.percent.toFixed(2) || 0)
										setShowEditModal(true)
									}
								)}
							</TableRow>
							<TableRow key={3}>
								<TableCell component="th" scope="row" sx={{padding: '6px 10px 6px 10px'}}>Other Income</TableCell>
								{renderSmallCell(`$${Helpers.getFormattedNumber(actuals?.other_income?.value || 0)} (${actuals?.other_income?.percent.toFixed(2) || 0}%)`)}
								{renderSmallCell(`$${Helpers.getFormattedNumber(proforma?.other_income?.value || 0)} (${proforma?.other_income?.percent.toFixed(2) || 0}%)`)}
								{renderSmallCellEditable(
									`$${Helpers.getFormattedNumber(manual?.other_income?.value || 0)} (${manual?.other_income?.percent.toFixed(2) || 0}%)`,
									() => {
										setEditFieldDisplay("other Income")
										setEditFieldName("other_income")
										setEditFieldValue(manual?.other_income?.value || 0)
										setEditFieldPercent(manual?.other_income?.percent.toFixed(2) || 0)
										setShowEditModal(true)
									}
								)}
							</TableRow>
							<TableRow key={4}>
								<TableCell component="th" scope="row" sx={{padding: '6px 10px 6px 10px'}}>Vacancy Factor</TableCell>
								{renderSmallCell(`-$${Helpers.getFormattedNumber(actuals?.vacancy?.value || 0)} (${actuals?.vacancy?.percent.toFixed(2) || 0}%)`)}
								{renderSmallCell(`-$${Helpers.getFormattedNumber(proforma?.vacancy?.value || 0)} (${proforma?.vacancy?.percent.toFixed(2) || 0}%)`)}
								{renderSmallCellEditable(
									`-$${Helpers.getFormattedNumber(manual?.vacancy?.value || 0)} (${manual?.vacancy?.percent.toFixed(2) || 0}%)`,
									() => {
										setEditFieldDisplay("Vacancy Factor")
										setEditFieldName("vacancy")
										setEditFieldValue(manual?.vacancy?.value || 0)
										setEditFieldPercent(manual?.vacancy?.percent.toFixed(2) || 0)
										setShowEditModal(true)
									}
								)}
							</TableRow>


							{/*expenses*/}
							<TableRow key={13}>
								<TableCell component="th" scope="row" sx={{padding: '12px 10px 12px 10px', fontWeight: '800'}}>Operating Expenses</TableCell>
								{renderBigCell(`$${Helpers.getFormattedNumber(totalExpensesActuals)} (${totalExpPercent.toFixed(2)}%)`)}
								{renderBigCell(`$${Helpers.getFormattedNumber(totalExpensesPro)} (${totalExpPercentPro.toFixed(2)}%)`)}
								{renderBigCell(`$${Helpers.getFormattedNumber(totalExpensesMan)} (${totalExpPercentMan.toFixed(2)}%)`)}
							</TableRow>
							<TableRow key={6}>
								<TableCell component="th" scope="row" sx={{padding: '6px 10px 6px 10px'}}>Property Taxes</TableCell>
								{renderSmallCell(`-$${Helpers.getFormattedNumber(actuals?.property_taxes?.value || 0)} (${actuals?.property_taxes?.percent.toFixed(2) || 0}%)`)}
								{renderSmallCell(`-$${Helpers.getFormattedNumber(proforma?.property_taxes?.value || 0)} (${proforma?.property_taxes?.percent.toFixed(2) || 0}%)`)}
								{renderSmallCellEditable(
									`-$${Helpers.getFormattedNumber(manual?.property_taxes?.value || 0)} (${manual?.property_taxes?.percent.toFixed(2) || 0}%)`,
									() => {
										setEditFieldDisplay("Property Taxes")
										setEditFieldName("property_taxes")
										setEditFieldValue(manual?.property_taxes?.value || 0)
										setEditFieldPercent(manual?.property_taxes?.percent.toFixed(2) || 0)
										setShowEditModal(true)
									}
								)}
							</TableRow>
							<TableRow key={7}>
								<TableCell component="th" scope="row" sx={{padding: '6px 10px 6px 10px'}}>Management Fees</TableCell>
								{renderSmallCell(`-$${Helpers.getFormattedNumber(actuals?.management_fees?.value || 0)} (${actuals?.management_fees?.percent.toFixed(2) || 0}%)`)}
								{renderSmallCell(`-$${Helpers.getFormattedNumber(proforma?.management_fees?.value || 0)} (${proforma?.management_fees?.percent.toFixed(2) || 0}%)`)}
								{renderSmallCellEditable(
									`-$${Helpers.getFormattedNumber(manual?.management_fees?.value || 0)} (${manual?.management_fees?.percent.toFixed(2) || 0}%)`,
									() => {
										setEditFieldDisplay("Management Fees")
										setEditFieldName("management_fees")
										setEditFieldValue(manual?.management_fees?.value || 0)
										setEditFieldPercent(manual?.management_fees?.percent.toFixed(2) || 0)
										setShowEditModal(true)
									}
								)}
							</TableRow>
							<TableRow key={8}>
								<TableCell component="th" scope="row" sx={{padding: '6px 10px 6px 10px'}}>Leasing Fees</TableCell>
								{renderSmallCell(`-$${Helpers.getFormattedNumber(actuals?.lease_fees?.value || 0)} (${actuals?.lease_fees?.percent.toFixed(2) || 0}%)`)}
								{renderSmallCell(`-$${Helpers.getFormattedNumber(proforma?.lease_fees?.value || 0)} (${proforma?.lease_fees?.percent.toFixed(2) || 0}%)`)}
								{renderSmallCellEditable(
									`-$${Helpers.getFormattedNumber(manual?.lease_fees?.value || 0)} (${manual?.lease_fees?.percent.toFixed(2) || 0}%)`,
									() => {
										setEditFieldDisplay("Leasing Fees")
										setEditFieldName("lease_fees")
										setEditFieldValue(manual?.lease_fees?.value || 0)
										setEditFieldPercent(manual?.lease_fees?.percent.toFixed(2) || 0)
										setShowEditModal(true)
									}
								)}
							</TableRow>
							<TableRow key={9}>
								<TableCell component="th" scope="row" sx={{padding: '6px 10px 6px 10px'}}>Property Insurance</TableCell>
								{renderSmallCell(`-$${Helpers.getFormattedNumber(actuals?.insurance?.value || 0)} (${actuals?.insurance?.percent.toFixed(2) || 0}%)`)}
								{renderSmallCell(`-$${Helpers.getFormattedNumber(proforma?.insurance?.value || 0)} (${proforma?.insurance?.percent.toFixed(2) || 0}%)`)}
								{renderSmallCellEditable(
									`-$${Helpers.getFormattedNumber(manual?.insurance?.value || 0)} (${manual?.insurance?.percent.toFixed(2) || 0}%)`,
									() => {
										setEditFieldDisplay("Property Insurance")
										setEditFieldName("insurance")
										setEditFieldValue(manual?.insurance?.value || 0)
										setEditFieldPercent(manual?.insurance?.percent.toFixed(2) || 0)
										setShowEditModal(true)
									}
								)}
							</TableRow>
							<TableRow key={10}>
								<TableCell component="th" scope="row" sx={{padding: '6px 10px 6px 10px'}}>Repairs & Maintenance</TableCell>
								{renderSmallCell(`-$${Helpers.getFormattedNumber(actuals?.repairs_maintenance?.value || 0)} (${actuals?.repairs_maintenance?.percent.toFixed(2) || 0}%)`)}
								{renderSmallCell(`-$${Helpers.getFormattedNumber(proforma?.repairs_maintenance?.value || 0)} (${proforma?.repairs_maintenance?.percent.toFixed(2) || 0}%)`)}
								{renderSmallCellEditable(
									`-$${Helpers.getFormattedNumber(manual?.repairs_maintenance?.value || 0)} (${manual?.repairs_maintenance?.percent.toFixed(2) || 0}%)`,
									() => {
										setEditFieldDisplay("Repairs & Maintenance")
										setEditFieldName("repairs_maintenance")
										setEditFieldValue(manual?.repairs_maintenance?.value || 0)
										setEditFieldPercent(manual?.repairs_maintenance?.percent.toFixed(2) || 0)
										setShowEditModal(true)
									}
								)}
							</TableRow>
							<TableRow key={11}>
								<TableCell component="th" scope="row" sx={{padding: '6px 10px 6px 10px'}}>Cap Ex Reserve</TableCell>
								{renderSmallCell(`-$${Helpers.getFormattedNumber(actuals?.cap_ex_reserve?.value || 0)} (${actuals?.cap_ex_reserve?.percent.toFixed(2) || 0}%)`)}
								{renderSmallCell(`-$${Helpers.getFormattedNumber(proforma?.cap_ex_reserve?.value || 0)} (${proforma?.cap_ex_reserve?.percent.toFixed(2) || 0}%)`)}
								{renderSmallCellEditable(
									`-$${Helpers.getFormattedNumber(manual?.cap_ex_reserve?.value || 0)} (${manual?.cap_ex_reserve?.percent.toFixed(2) || 0}%)`,
									() => {
										setEditFieldDisplay("Cap Ex Reserve")
										setEditFieldName("cap_ex_reserve")
										setEditFieldValue(manual?.cap_ex_reserve?.value || 0)
										setEditFieldPercent(manual?.cap_ex_reserve?.percent.toFixed(2) || 0)
										setShowEditModal(true)
									}
								)}
							</TableRow>
							<TableRow key={12}>
								<TableCell component="th" scope="row" sx={{padding: '6px 10px 6px 10px'}}>Other / Misc</TableCell>
								{renderSmallCell(
									`-$${Helpers.getFormattedNumber(actuals?.other?.value || 0)} (${actuals?.other?.percent.toFixed(2) || 0}%)`,
									() => {
										setShowExpensesModal(true)
									}
								)}
								{renderSmallCell(`-$${Helpers.getFormattedNumber(proforma?.other?.value || 0)} (${proforma?.other?.percent.toFixed(2) || 0}%)`)}
								{renderSmallCellEditable(
									`-$${Helpers.getFormattedNumber(manual?.other?.value || 0)} (${manual?.other?.percent.toFixed(2) || 0}%)`,
									() => {
										setEditFieldDisplay("Other/Misc")
										setEditFieldName("other")
										setEditFieldValue(manual?.other?.value || 0)
										setEditFieldPercent(manual?.other?.percent.toFixed(2) || 0)
										setShowEditModal(true)
									}
								)}
							</TableRow>

							<TableRow key={14}>
								<TableCell component="th" scope="row" sx={{padding: '12px 10px 12px 10px', fontWeight: '800'}}>Net Operating Income</TableCell>
								{renderBigCell(`$${Helpers.getFormattedNumber(NOIActuals)} (${NOIActualsPercent.toFixed(2)}%)`)}
								{renderBigCell(`$${Helpers.getFormattedNumber(NOIPro)} (${NOIProPercent.toFixed(2)}%)`)}
								{renderBigCell(`$${Helpers.getFormattedNumber(NOIMan)} (${NOIManPercent.toFixed(2)}%)`)}
							</TableRow>
							<TableRow key={15}>
								<TableCell component="th" scope="row" sx={{padding: '6px 10px 6px 10px'}}>NOI Margin</TableCell>
								{renderSmallCell(`${NOIMarginActuals.toFixed(2)}%`)}
								{renderSmallCell(`${NOIMarginPro.toFixed(2)}%`)}
								{renderSmallCell(`${NOIMarginMan.toFixed(2)}%`)}
							</TableRow>
							<TableRow key={16}>
								<TableCell component="th" scope="row" sx={{padding: '6px 10px 6px 10px'}}>Income to Expense Ratio</TableCell>
								{renderSmallCell(`${totalExpensesActuals > 0 ? (grossIncomeActuals/totalExpensesActuals).toFixed(2) : 0.00}`)}
								{renderSmallCell(`${totalExpensesPro > 0 ? (grossIncomePro/totalExpensesPro).toFixed(2) : 0.00}`)}
								{renderSmallCell(`${totalExpensesMan > 0 ? (grossIncomeMan/totalExpensesMan).toFixed(2) : 0.00}`)}
							</TableRow>

						</TableBody>
					</Table>

					<div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', marginTop: 20, width: '100%'}}>
						<CustomTextFieldNew
							width={'30%'}
							label={`Mortgage ($)`}
							placeholder={`enter mortgage value`}
							value={mortgage}
							onChange={(text) => {
								if (Helpers.checkIfNumber(text)) {
									setMortgage(text)
								}
							}}
						/>


					</div>

					<Table sx={{ width: '100%', marginTop: 2}} aria-label="simple table 2">
						<TableBody>
							<TableRow key={8}>
								<TableCell component="th" scope="row" sx={{width: '28%', padding: '6px 10px 6px 10px'}}>DSCR</TableCell>
								{renderSmallCell2(mortgage && Helpers.checkIfNumber(mortgage) && Number(mortgage) > 0 ? (NOIActuals/mortgage).toFixed(2) : 'N/A')}
								{renderSmallCell2(mortgage && Helpers.checkIfNumber(mortgage) && Number(mortgage) > 0 ? (NOIPro/mortgage).toFixed(2) : 'N/A')}
								{renderSmallCell2(mortgage && Helpers.checkIfNumber(mortgage) && Number(mortgage) > 0 ? (NOIMan/mortgage).toFixed(2) : 'N/A')}
							</TableRow>
							<TableRow key={7}>
								<TableCell component="th" scope="row" sx={{width: '28%', fontWeight: 'bold', padding: '12px 10px 12px 10px'}}>Mortgage</TableCell>
								<TableCell sx={{width: '24%', fontWeight: 'bold', padding: '12px 10px 12px 10px'}}><p className={Styles.entryText2}>${Helpers.getFormattedNumber(mortgage)}</p></TableCell>
								<TableCell sx={{width: '24%', fontWeight: 'bold', padding: '12px 10px 12px 10px'}}><p className={Styles.entryText2}>${Helpers.getFormattedNumber(mortgage)}</p></TableCell>
								<TableCell sx={{width: '24%', fontWeight: 'bold', padding: '12px 10px 12px 10px'}}><p className={Styles.entryText2}>${Helpers.getFormattedNumber(mortgage)}</p></TableCell>
							</TableRow>
							<TableRow key={1}>
								<TableCell component="th" scope="row" sx={{width: '28%', fontWeight: 'bold', padding: '12px 10px 12px 10px'}}>Net Income(Post Mortgage)</TableCell>
								<TableCell sx={{width: '24%', fontWeight: 'bold', padding: '12px 10px 12px 10px'}}><p className={Styles.entryText2}>${Helpers.getFormattedNumber((NOIActuals - Number(mortgage)).toFixed(2))}</p></TableCell>
								<TableCell sx={{width: '24%', fontWeight: 'bold', padding: '12px 10px 12px 10px'}}><p className={Styles.entryText2}>${Helpers.getFormattedNumber((NOIPro - Number(mortgage)).toFixed(2))}</p></TableCell>
								<TableCell sx={{width: '24%', fontWeight: 'bold', padding: '12px 10px 12px 10px'}}><p className={Styles.entryText2}>${Helpers.getFormattedNumber((NOIMan - Number(mortgage)).toFixed(2))}</p></TableCell>
							</TableRow>


							<TableRow key={2}>
								<TableCell component="th" scope="row" sx={{width: '28%', padding: '6px 10px 6px 10px'}}>{`Tier 1 - ${Number(dscr_tiers[0]).toFixed(2)} DSCR`}</TableCell>
								{renderSmallCell2(`$${Helpers.getFormattedNumber(Number(((NOIActuals - Number(mortgage))/dscr_tiers[0]).toFixed(2)))}`)}
								{renderSmallCell2(`$${Helpers.getFormattedNumber(Number(((NOIPro - Number(mortgage))/dscr_tiers[0]).toFixed(2)))}`)}
								{renderSmallCell2(`$${Helpers.getFormattedNumber(Number(((NOIMan - Number(mortgage))/dscr_tiers[0]).toFixed(2)))}`)}
							</TableRow>

							<TableRow key={3}>
								<TableCell component="th" scope="row" sx={{width: '28%', padding: '6px 10px 6px 10px'}}>Per Month</TableCell>
								{renderSmallCell2(`$${Helpers.getFormattedNumber(Number(((NOIActuals - Number(mortgage))/(dscr_tiers[0]*12)).toFixed(2)))}`)}
								{renderSmallCell2(`$${Helpers.getFormattedNumber(Number(((NOIPro - Number(mortgage))/(dscr_tiers[0]*12)).toFixed(2)))}`)}
								{renderSmallCell2(`$${Helpers.getFormattedNumber(Number(((NOIMan - Number(mortgage))/(dscr_tiers[0]*12)).toFixed(2)))}`)}
							</TableRow>
							<TableRow key={4}>
								<TableCell component="th" scope="row" sx={{width: '28%', padding: '12px 10px 12px 10px'}}></TableCell>
								{renderSmallCell2()}
								{renderSmallCell2()}
								{renderSmallCell2()}
							</TableRow>

							<TableRow key={5}>
								<TableCell component="th" scope="row" sx={{width: '28%', padding: '6px 10px 6px 10px'}}>{`Tier 2 - ${Number(dscr_tiers[1]).toFixed(2)} DSCR`}</TableCell>
								{renderSmallCell2(`$${Helpers.getFormattedNumber(Number(((NOIActuals - Number(mortgage))/dscr_tiers[1]).toFixed(2)))}`)}
								{renderSmallCell2(`$${Helpers.getFormattedNumber(Number(((NOIPro - Number(mortgage))/dscr_tiers[1]).toFixed(2)))}`)}
								{renderSmallCell2(`$${Helpers.getFormattedNumber(Number(((NOIMan - Number(mortgage))/dscr_tiers[1]).toFixed(2)))}`)}
							</TableRow>
							<TableRow key={6}>
								<TableCell component="th" scope="row" sx={{width: '28%', padding: '6px 10px 6px 10px'}}>Per Month</TableCell>
								{renderSmallCell2(`$${Helpers.getFormattedNumber(Number(((NOIActuals - Number(mortgage))/(dscr_tiers[1]*12)).toFixed(2)))}`)}
								{renderSmallCell2(`$${Helpers.getFormattedNumber(Number(((NOIPro - Number(mortgage))/(dscr_tiers[1]*12)).toFixed(2)))}`)}
								{renderSmallCell2(`$${Helpers.getFormattedNumber(Number(((NOIMan - Number(mortgage))/(dscr_tiers[1]*12)).toFixed(2)))}`)}
							</TableRow>

							{/*<TableRow key={4}>*/}
							{/*	<TableCell component="th" scope="row" sx={{width: '34%', padding: '6px 10px 6px 10px'}}>Tier 3 (DSCR {dscr_tiers[2]})</TableCell>*/}
							{/*	{renderSmallCell2(`$${Helpers.getFormattedNumber(Math.round((NOIActuals - Number(mortgage))/dscr_tiers[2]))}`)}*/}
							{/*	{renderSmallCell2(`$${Helpers.getFormattedNumber(Math.round((NOIPro - Number(mortgage))/dscr_tiers[2]))}`)}*/}
							{/*	{renderSmallCell2Selectable(*/}
							{/*		`$${Helpers.getFormattedNumber(Math.round((NOIMan - Number(mortgage))/dscr_tiers[2]))}`,*/}
							{/*		3,*/}
							{/*		() => {*/}
							{/*			setSelectedAmount(Math.round((NOIMan - Number(mortgage))/dscr_tiers[2]))*/}
							{/*			setSelectedDSCRTier(3)*/}
							{/*		}*/}
							{/*	)}*/}
							{/*</TableRow>*/}

						</TableBody>
					</Table>


				</div>

			</div>
		)
	}


	const renderSmallCell2 = (string) => {
		return (
			<TableCell sx={{width: '24%', padding: '6px 10px 6px 10px'}}><p className={Styles.entryText2}>{string}</p></TableCell>
		)
	}

	const renderSmallCell2Selectable = (string, dscrTier, onClick) => {
		return (
			<TableCell
				sx={{
					width: '24%',
					padding: '6px 10px 6px 10px',
					cursor: onClick ? 'pointer': 'default',
					backgroundColor: 'transparent',
				}}
				onClick={onClick}
			>
				<p className={Styles.entryText2}>{string}</p>
			</TableCell>
		)
	}

	const renderPropertyDetails = () => {
		let startDate = propertyActuals?.start_date ? moment(propertyActuals.start_date) : 'N/A'
		let endDate = propertyActuals?.end_date ? moment(propertyActuals.end_date) : 'N/A'
		let {property_address_line_one, city, property_address_city, property_address_region, property_address_postal_code} = activeUnderwriting || {}

		return (
			<div style={{width: '48%', border: `1px solid ${Colors.tableLineColor}`, borderRadius: 10, padding: 8}}>
				<div className={Styles.row}>
					<p className={Styles.labelText}>Property ID</p>
					<p className={Styles.entryText}>{activeUnderwriting?.property_id}</p>
				</div>
				<div className={Styles.row}>
					<p className={Styles.labelText}>Unit ID</p>
					<p className={Styles.entryText}>{activeUnderwriting?.work_order_unit_id}</p>
				</div>
				<div className={Styles.row}>
					<p className={Styles.labelText}>Category</p>
					<p className={Styles.entryText}>{activeUnderwriting?.property_category}</p>
				</div>
				<div className={Styles.row}>
					<p className={Styles.labelText}>Address</p>
					<p className={Styles.entryText}>{`${property_address_line_one}, ${property_address_city}, ${property_address_region} ${property_address_postal_code}`}</p>
				</div>
				<div className={Styles.row}>
					<p className={Styles.labelText}>Status</p>
					<p className={Styles.entryText}>{activeUnderwriting?.property_status}</p>
				</div>
				<div className={Styles.row}>
					<p className={Styles.labelText}>Bedrooms</p>
					<p className={Styles.entryText}>{`${activeUnderwriting?.property_bedrooms}`}</p>
				</div>
				<div className={Styles.row}>
					<p className={Styles.labelText}>Bathrooms</p>
					<p className={Styles.entryText}>{activeUnderwriting?.property_bathrooms}</p>
				</div>
				<div className={Styles.row}>
					<p className={Styles.labelText}>Area</p>
					<p className={Styles.entryText}>{`${Helpers.getFormattedNumber(activeUnderwriting?.property_square_feet || 0)} sq ft`}</p>
				</div>
				<div className={Styles.row}>
					<p className={Styles.labelText}>Current Lease</p>
					{propertyActuals &&
						<p className={Styles.entryText}>{typeof startDate === 'string' ? 'N/A':startDate.format(DATE_FORMAT)} - {typeof endDate === 'string' ? 'N/A' : endDate.format(DATE_FORMAT)}</p>
					}
				</div>
				<div className={Styles.row}>
					<p className={Styles.labelText}>Monthly Rent</p>
					{propertyActuals &&
						<p className={Styles.entryText}>{typeof propertyActuals?.base_rent === 'number' ? `$${Helpers.getFormattedNumber(Number((propertyActuals?.base_rent).toFixed(2)))}` : 'N/A'}</p>
					}
				</div>
				<div className={Styles.row}>
					<p className={Styles.labelText}>Annualized Rent</p>
					{propertyActuals &&
						<p className={Styles.entryText}>{typeof propertyActuals?.base_rent === 'number' ? `$${Helpers.getFormattedNumber(Number((propertyActuals?.base_rent*12).toFixed(2)))}` : 'N/A'}</p>
					}
				</div>
				<div className={Styles.row}>
					<p className={Styles.labelText}>Security Deposit</p>
					{propertyActuals &&
						<p className={Styles.entryText}>{typeof propertyActuals?.security_deposit === 'number' ? `$${Helpers.getFormattedNumber(propertyActuals?.security_deposit)}` : 'N/A'}</p>
					}
				</div>
				<div className={Styles.row}>
					<p className={Styles.labelText}>Owner(s)</p>
					<div style={{width: '100%'}}>
						{owners &&
							owners.map(owner => (
								<div style={{borderBottom: `0.5px dotted gray`, width: '100%'}}>
									<p style={{color: Colors.secondaryTextColor, fontSize: Constants.entryTextSize}}>{owner.name}</p>
									<p style={{color: Colors.primaryTextColor, fontSize: Constants.entryTextSize}}>{`${owner.phone} - ${owner.email}`}</p>
								</div>
							))
						}
					</div>
				</div>
			</div>
		)

	}

	const renderWorkOrderDetails = () => {
		if(!activeUnderwriting) return null
		let tags = activeUnderwriting?.work_order_tags ? JSON.parse(activeUnderwriting?.work_order_tags).join(', ') : ''
		return (
			<div style={{width: '48%', border: `1px solid ${Colors.tableLineColor}`, borderRadius: 10, padding: 8}}>
				<div className={Styles.row}>
					<p className={Styles.labelText}>Work Order ID</p>
					<p className={Styles.entryText}>{activeUnderwriting?._id}</p>
				</div>
				<div className={Styles.row}>
					<p className={Styles.labelText}>Subject</p>
					<p className={Styles.entryText}>{activeUnderwriting?.work_order_subject}</p>
				</div>
				<div className={Styles.row}>
					<p className={Styles.labelText}>Description</p>
					<p className={Styles.entryText}>{activeUnderwriting?.work_order_description}</p>
				</div>
				<div className={Styles.row}>
					<p className={Styles.labelText}>Status</p>
					<p className={Styles.entryText}>{activeUnderwriting?.work_order_status}</p>
				</div>
				<div className={Styles.row}>
					<p className={Styles.labelText}>Urgency</p>
					<p className={Styles.entryText}>{activeUnderwriting?.work_order_urgency}</p>
				</div>
				<div className={Styles.row}>
					<p className={Styles.labelText}>Cost</p>
					<p className={Styles.entryText}>${Helpers.getFormattedNumber(activeUnderwriting?.work_order_cost || 0)}</p>
				</div>
				<div className={Styles.row}>
					<p className={Styles.labelText}>Tags</p>
					<p className={Styles.entryText}>{tags || ''}</p>
				</div>
				<div className={Styles.row}>
					<p className={Styles.labelText}>Created At</p>
					<p className={Styles.entryText}>{activeUnderwriting?.work_order_created_at ? moment(activeUnderwriting.work_order_created_at).format('MMM Do, YYYY hh:mm A') : ''}</p>
				</div>

			</div>
		)
	}

	const getLoanFeeInputBox = () => {
		if(!loanFeeOption)
			return null

		let dscr_tiers = assumptions?.underwriting?.dscr_tiers || []
		let selectedAmount1 = Number(((NOIMan - Number(mortgage))/dscr_tiers[0]).toFixed(2))

		if(loanFeeOption?.value === 0)
			return (
				<CustomTextFieldNew
					marginLeft={20}
					width={'40%'}
					label={`Loan Points/Fee ($)`}
					placeholder={`enter loan points/fee value`}
					value={loanFee}
					onChange={(text) => {
						if (Helpers.checkIfNumber(text)) {
							if(Number(text) > Number(selectedAmount1)){
								setErrorMessage('Loan Points/Fee cannot be more than 20% of the amount')
								setShowError(true)
							} else{
								setLoanFee(text)
							}
						}
					}}
				/>
			)
		else
			return (
				<CustomTextFieldNew
					marginLeft={20}
					width={'40%'}
					label={`Loan Points/Fee (%)`}
					placeholder={`enter loan points/fee percentage`}
					value={loanFee}
					onChange={(text) => {
						if (Helpers.checkIfNumber(text)) {
							if(Number(text) > 20) {
								setErrorMessage('Loan Points/Fee cannot be more than 20% of the amount')
								setShowError(true)
							} else {
								setLoanFee(text)
							}

						}
					}}
				/>
			)
	}

	const renderManualLoanTable = () => {
		if(!manualTableData)
			return null

		let style = {width: '20%', padding: '6px 10px 6px 10px'}
		let sixMonthRate = Number(manualTableData["6"]?.rate)
		let nineMonthRate = Number(manualTableData["9"]?.rate)
		let twelveMonthRate = Number(manualTableData["12"]?.rate)
		let eighteenMonthRate = Number(manualTableData["18"]?.rate)
		let perMonthAmount6 = Number(manualTableData["6"]?.amount)
		let perMonthAmount9 = Number(manualTableData["9"]?.amount)
		let perMonthAmount12 = Number(manualTableData["12"]?.amount)
		let perMonthAmount18 = Number(manualTableData["18"]?.amount)

		let presentValueAnnuity6 = perMonthAmount6
		let presentValueAnnuity9 = perMonthAmount9
		let presentValueAnnuity12 = perMonthAmount12
		let presentValueAnnuity18 = perMonthAmount18

		let pmt6 = Helpers.PMT(sixMonthRate / 1200, 6, presentValueAnnuity6, 0, 1)
		let pmt9 = Helpers.PMT(nineMonthRate / 1200, 9, presentValueAnnuity9, 0, 1)
		let pmt12 = Helpers.PMT(twelveMonthRate / 1200, 12, presentValueAnnuity12, 0, 1)
		let pmt18 = Helpers.PMT(eighteenMonthRate / 1200, 18, presentValueAnnuity18, 0, 1)

		let totalPayment6 =  pmt6 * 6
		let totalPayment9 =  pmt9 * 9
		let totalPayment12 =  pmt12 * 12
		let totalPayment18 =  pmt18 * 18

		let totalInterest6 = totalPayment6 + presentValueAnnuity6
		let totalInterest9 = totalPayment9 + presentValueAnnuity9
		let totalInterest12 = totalPayment12 + presentValueAnnuity12
		let totalInterest18 = totalPayment18 + presentValueAnnuity18



		return (
			<Table sx={{ width: '100%', marginTop: 2}} aria-label="simple table 3">
				<TableBody>
					<TableRow key={1}>
						<TableCell sx={style}>Max Loan Amount</TableCell>
						{renderSmallCellEditable2(style, `$${Helpers.getFormattedNumber(perMonthAmount6)}`, () => {
							setManualModalString('Change the max loan amount for 6 months')
							setManualModalSelectedValue(['6', 'amount'])
							setManualModalEntryPlaceholder('Max Loan Amount ($)')
							setManualModalEntryValue(manualTableData['6']['amount'])
							setShowManualEntryModal(true)
						})}
						{renderSmallCellEditable2(style, `$${Helpers.getFormattedNumber(perMonthAmount9)}`, () => {
							setManualModalString('Change the max loan amount for 9 months')
							setManualModalSelectedValue(['9', 'amount'])
							setManualModalEntryPlaceholder('Max Loan Amount ($)')
							setManualModalEntryValue(manualTableData['9']['amount'])
							setShowManualEntryModal(true)
						})}
						{renderSmallCellEditable2(style, `$${Helpers.getFormattedNumber(perMonthAmount12)}`, () => {
							setManualModalString('Change the max loan amount for 12 months')
							setManualModalSelectedValue(['12', 'amount'])
							setManualModalEntryPlaceholder('Max Loan Amount ($)')
							setManualModalEntryValue(manualTableData['12']['amount'])
							setShowManualEntryModal(true)
						})}
						{renderSmallCellEditable2(style, `$${Helpers.getFormattedNumber(perMonthAmount18)}`, () => {
							setManualModalString('Change the max loan amount for 18 months')
							setManualModalSelectedValue(['18', 'amount'])
							setManualModalEntryPlaceholder('Max Loan Amount ($)')
							setManualModalEntryValue(manualTableData['18']['amount'])
							setShowManualEntryModal(true)
						})}
					</TableRow>
					<TableRow key={2}>
						<TableCell sx={style}>Months</TableCell>
						<TableCell sx={style}>6</TableCell>
						<TableCell sx={style}>9</TableCell>
						<TableCell sx={style}>12</TableCell>
						<TableCell sx={style}>18</TableCell>
					</TableRow>
					<TableRow key={3}>
						<TableCell sx={style}>APR</TableCell>
						{renderSmallCellEditable2(style, `${sixMonthRate?.toFixed(2)}%`, () => {
							setManualModalString('Change the APR for 6 months')
							setManualModalSelectedValue(['6', 'rate'])
							setManualModalEntryPlaceholder('6 Months APR(%)')
							setManualModalEntryValue(manualTableData['6']['rate'])
							setShowManualEntryModal(true)
						})}
						{renderSmallCellEditable2(style, `${nineMonthRate?.toFixed(2)}%`, () => {
							setManualModalString('Change the APR for 9 months')
							setManualModalSelectedValue(['9', 'rate'])
							setManualModalEntryPlaceholder('9 Months APR(%)')
							setManualModalEntryValue(manualTableData['9']['rate'])
							setShowManualEntryModal(true)
						})}
						{renderSmallCellEditable2(style, `${twelveMonthRate?.toFixed(2)}%`, () => {
							setManualModalString('Change the APR for 12 months')
							setManualModalSelectedValue(['12', 'rate'])
							setManualModalEntryPlaceholder('12 Months APR(%)')
							setManualModalEntryValue(manualTableData['12']['rate'])
							setShowManualEntryModal(true)
						})}
						{renderSmallCellEditable2(style, `${eighteenMonthRate?.toFixed(2)}%`, () => {
							setManualModalString('Change the APR for 18 months')
							setManualModalSelectedValue(['18', 'rate'])
							setManualModalEntryPlaceholder('18 Months APR(%)')
							setManualModalEntryValue(manualTableData['18']['rate'])
							setShowManualEntryModal(true)
						})}
					</TableRow>
					<TableRow key={4}>
						<TableCell sx={style}>Monthly Payment</TableCell>
						<TableCell sx={style}>${Helpers.getFormattedNumber(Number(pmt6.toFixed(2)))}</TableCell>
						<TableCell sx={style}>${Helpers.getFormattedNumber(Number(pmt9.toFixed(2)))}</TableCell>
						<TableCell sx={style}>${Helpers.getFormattedNumber(Number(pmt12.toFixed(2)))}</TableCell>
						<TableCell sx={style}>${Helpers.getFormattedNumber(Number(pmt18.toFixed(2)))}</TableCell>
					</TableRow>
					<TableRow key={5}>
						<TableCell sx={style}>Total interest</TableCell>
						<TableCell sx={style}>${Helpers.getFormattedNumber(Number(totalInterest6.toFixed(2)))}</TableCell>
						<TableCell sx={style}>${Helpers.getFormattedNumber(Number(totalInterest9.toFixed(2)))}</TableCell>
						<TableCell sx={style}>${Helpers.getFormattedNumber(Number(totalInterest12.toFixed(2)))}</TableCell>
						<TableCell sx={style}>${Helpers.getFormattedNumber(Number(totalInterest18.toFixed(2)))}</TableCell>
					</TableRow>
					<TableRow key={6}>
						<TableCell sx={style}>Total Payment</TableCell>
						<TableCell sx={style}>${Helpers.getFormattedNumber(Number(totalPayment6.toFixed(2)))}</TableCell>
						<TableCell sx={style}>${Helpers.getFormattedNumber(Number(totalPayment9.toFixed(2)))}</TableCell>
						<TableCell sx={style}>${Helpers.getFormattedNumber(Number(totalPayment12.toFixed(2)))}</TableCell>
						<TableCell sx={style}>${Helpers.getFormattedNumber(Number(totalPayment18.toFixed(2)))}</TableCell>
					</TableRow>
				</TableBody>
			</Table>
		)

	}

	const renderLoanTable = (perMonthAmount, sixMonthRate, nineMonthRate, twelveMonthRate, eighteenMonthRate) => {



		const renderTable = () => {
			let style = {width: '20%', padding: '6px 10px 6px 10px'}
			let presentValueAnnuity6 = Helpers.calcPresentValueAnnuity(perMonthAmount, sixMonthRate, 6)
			let presentValueAnnuity9 = Helpers.calcPresentValueAnnuity(perMonthAmount, nineMonthRate, 9)
			let presentValueAnnuity12 = Helpers.calcPresentValueAnnuity(perMonthAmount, twelveMonthRate, 12)
			let presentValueAnnuity18 = Helpers.calcPresentValueAnnuity(perMonthAmount, eighteenMonthRate, 18)

			let pmt6 = Helpers.PMT(sixMonthRate / 1200, 6, presentValueAnnuity6, 0, 1)
			let pmt9 = Helpers.PMT(nineMonthRate / 1200, 9, presentValueAnnuity9, 0, 1)
			let pmt12 = Helpers.PMT(twelveMonthRate / 1200, 12, presentValueAnnuity12, 0, 1)
			let pmt18 = Helpers.PMT(eighteenMonthRate / 1200, 18, presentValueAnnuity18, 0, 1)

			let totalPayment6 =  pmt6 * 6
			let totalPayment9 =  pmt9 * 9
			let totalPayment12 =  pmt12 * 12
			let totalPayment18 =  pmt18 * 18

			let totalInterest6 = totalPayment6 + presentValueAnnuity6
			let totalInterest9 = totalPayment9 + presentValueAnnuity9
			let totalInterest12 = totalPayment12 + presentValueAnnuity12
			let totalInterest18 = totalPayment18 + presentValueAnnuity18

			return (
				<Table sx={{ width: '100%', marginTop: 2}} aria-label="simple table 3">
					<TableBody>
						<TableRow key={1}>
							<TableCell sx={style}>Max Loan Amount</TableCell>
							<TableCell sx={style}>${Helpers.getFormattedNumber(Helpers.calcPresentValueAnnuity(perMonthAmount, sixMonthRate, 6))}</TableCell>
							<TableCell sx={style}>${Helpers.getFormattedNumber(Helpers.calcPresentValueAnnuity(perMonthAmount, nineMonthRate, 9))}</TableCell>
							<TableCell sx={style}>${Helpers.getFormattedNumber(Helpers.calcPresentValueAnnuity(perMonthAmount, twelveMonthRate, 12))}</TableCell>
							<TableCell sx={style}>${Helpers.getFormattedNumber(Helpers.calcPresentValueAnnuity(perMonthAmount, eighteenMonthRate, 18))}</TableCell>
						</TableRow>
						<TableRow key={2}>
							<TableCell sx={style}>Months</TableCell>
							<TableCell sx={style}>6</TableCell>
							<TableCell sx={style}>9</TableCell>
							<TableCell sx={style}>12</TableCell>
							<TableCell sx={style}>18</TableCell>
						</TableRow>
						<TableRow key={3}>
							<TableCell sx={style}>APR</TableCell>
							<TableCell sx={style}>{sixMonthRate?.toFixed(2)}%</TableCell>
							<TableCell sx={style}>{nineMonthRate?.toFixed(2)}%</TableCell>
							<TableCell sx={style}>{twelveMonthRate?.toFixed(2)}%</TableCell>
							<TableCell sx={style}>{eighteenMonthRate?.toFixed(2)}%</TableCell>
						</TableRow>
						<TableRow key={4}>
							<TableCell sx={style}>Monthly Payment</TableCell>
							<TableCell sx={style}>${Helpers.getFormattedNumber(Number(pmt6.toFixed(2)))}</TableCell>
							<TableCell sx={style}>${Helpers.getFormattedNumber(Number(pmt9.toFixed(2)))}</TableCell>
							<TableCell sx={style}>${Helpers.getFormattedNumber(Number(pmt12.toFixed(2)))}</TableCell>
							<TableCell sx={style}>${Helpers.getFormattedNumber(Number(pmt18.toFixed(2)))}</TableCell>
						</TableRow>
						<TableRow key={5}>
							<TableCell sx={style}>Total interest</TableCell>
							<TableCell sx={style}>${Helpers.getFormattedNumber(Number(totalInterest6.toFixed(2)))}</TableCell>
							<TableCell sx={style}>${Helpers.getFormattedNumber(Number(totalInterest9.toFixed(2)))}</TableCell>
							<TableCell sx={style}>${Helpers.getFormattedNumber(Number(totalInterest12.toFixed(2)))}</TableCell>
							<TableCell sx={style}>${Helpers.getFormattedNumber(Number(totalInterest18.toFixed(2)))}</TableCell>
						</TableRow>
						<TableRow key={6}>
							<TableCell sx={style}>Total Payment</TableCell>
							<TableCell sx={style}>${Helpers.getFormattedNumber(Number(totalPayment6.toFixed(2)))}</TableCell>
							<TableCell sx={style}>${Helpers.getFormattedNumber(Number(totalPayment9.toFixed(2)))}</TableCell>
							<TableCell sx={style}>${Helpers.getFormattedNumber(Number(totalPayment12.toFixed(2)))}</TableCell>
							<TableCell sx={style}>${Helpers.getFormattedNumber(Number(totalPayment18.toFixed(2)))}</TableCell>
						</TableRow>
					</TableBody>
				</Table>
			)
		}

		return renderTable()
	}

	const renderPhotosModal = () => {
		if(!zillowData)
			return null
		let {address, photos} = zillowData
		let addressString = `${address?.streetAddress}, ${address?.city}, ${address?.state}, ${address?.zipcode}`
		let temp = []
		photos.forEach(photo => {
			let temp2= Object.values(photo.mixedSources)[0][0].url
			temp.push(temp2)
		})

		return (
			<CustomModal
				show={showPhotos}
				handleClose={() => setShowPhotos(false)}
				containerWidth={window.innerWidth - 50}
				containerHeight={window.innerHeight - 50}
			>
				<div style={{
					width: '100%',
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					height: '100%',
					border: 0
				}}>
					<div style={{display: 'flex', position: 'relative', width: '100%', flexDirection: 'column', alignItems: 'center'}}>
						<div style={{width: '100%', display: 'flex', flexDirection: 'column'}}>
							<label style={{width: '100%', textAlign: 'center', fontSize: CONSTANTS.headerSize, fontWeight: 'bold', color: Colors.primaryTextColor}}>Property Photos</label>
							<label style={{color: Colors.secondaryTextColor, fontSize: CONSTANTS.labelSize, width: '100%', textAlign: 'center'}}>{addressString}</label>
						</div>
						<p
							style={{textDecoration:'underline', color: Colors.secondaryTextColor, cursor: 'pointer', position: 'absolute', right: 6, top: 4}}
							onClick={() => setShowPhotos(false)}
						>
							X Close
						</p>
					</div>
					<div style={{height: '100%', width: '90%'}}>
						<Carousel navButtonsAlwaysVisible={true}>
							{
								temp.map( (item, i) =>  <ImageRender key={i.toString()} image={item}/>)
							}
						</Carousel>
					</div>
				</div>
			</CustomModal>
		)
	}

	function ImageRender({image, key}) {
		return (
			<div key={key} style={{width: '50%', minHeight: 100, margin: '0 auto'}}>
				<img src={image} width={'100%'} height={'100%'} style={{borderRadius: 10}}/>
			</div>

			// <div className={Styles.imageContainer}>
			// 	<img
			// 		key={key}
			// 		src={image}
			// 		style={{
			// 			width: '100%',
			// 			height: '100%',
			// 			objectFit: 'contain'
			// 		}}
			// 	/>
			// </div>
		)
	}

	const renderIncomeModal = () => {
		let allIncome = propertyActuals?.income?.allIncome || []
		return (
			<CustomModal
				show={showIncomeModal}
				handleClose={() => setShowIncomeModal(false)}
				containerWidth={window.innerWidth/1.5}
				containerHeight={window.innerHeight/1.5}
			>
				<div style={{
					width: '100%',
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					height: '100%',
					overflowY: 'scroll'
				}}>
					<label style={{width: '100%', textAlign: 'center', fontSize: CONSTANTS.headerSize, fontWeight: 'bold', color: Colors.primaryTextColor}}>Property Income</label>
					<label style={{width: '100%', textAlign: 'center', fontSize: CONSTANTS.entryTextSize, color: Colors.secondaryTextColor}}>{`${moment().subtract(1, 'year').format(DATE_FORMAT)} to ${moment().format(DATE_FORMAT)}`}</label>

					<Table sx={{ width: '90%', marginTop: 2, marginBottom: 2}} aria-label="simple table">
						<TableHead>
							<TableRow>
								<TableCell sx={{padding: '10px', width: '15%'}}>Invoice ID</TableCell>
								<TableCell sx={{padding: '10px', width: '45%'}}>Description</TableCell>
								<TableCell sx={{padding: '10px', width: '15%'}}>Invoice Date</TableCell>
								<TableCell sx={{padding: '10px', width: '15%'}}>Amount</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{allIncome.map((income, index) => (
								<TableRow key={index}>
									<TableCell sx={{padding: '10px', width: '15%'}}>{income.invoice_id}</TableCell>
									<TableCell sx={{padding: '10px', width: '45%'}}>{income.description}</TableCell>
									<TableCell sx={{padding: '10px', width: '15%'}}>{moment(income.invoice_date).format(DATE_FORMAT)}</TableCell>
									<TableCell sx={{padding: '10px', width: '15%'}}>${income.invoice_pricing}</TableCell>
								</TableRow>
							))}
						</TableBody>
					</Table>
				</div>
			</CustomModal>
		)
	}

	const renderExpensesModal = () => {
		let allExpenses = propertyActuals?.expenses?.allExpenses || []
		return (
			<CustomModal
				show={showExpensesModal}
				handleClose={() => setShowExpensesModal(false)}
				containerWidth={window.innerWidth/1.5}
				containerHeight={window.innerHeight/1.5}
			>
				<div style={{
					width: '100%',
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					height: '100%',
					overflowY: 'scroll'
				}}>
					<label style={{width: '100%', textAlign: 'center', fontSize: CONSTANTS.headerSize, fontWeight: 'bold', color: Colors.primaryTextColor}}>Property Expenses</label>
					<label style={{width: '100%', textAlign: 'center', fontSize: CONSTANTS.entryTextSize, color: Colors.secondaryTextColor}}>{`${moment().subtract(1, 'year').format(DATE_FORMAT)} to ${moment().format(DATE_FORMAT)}`}</label>

					<Table sx={{ width: '90%', marginTop: 2, marginBottom: 2}} aria-label="simple table">
						<TableHead>
							<TableRow>
								<TableCell sx={{padding: '10px', width: '15%'}}>Invoice ID</TableCell>
								<TableCell sx={{padding: '10px', width: '45%'}}>Description</TableCell>
								<TableCell sx={{padding: '10px', width: '15%'}}>Invoice Date</TableCell>
								<TableCell sx={{padding: '10px', width: '15%'}}>Amount</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{allExpenses.map((expense, index) => (
                <TableRow key={index}>
                  <TableCell sx={{padding: '10px', width: '15%'}}>{expense.invoice_id}</TableCell>
                  <TableCell sx={{padding: '10px', width: '45%'}}>{expense.description}</TableCell>
                  <TableCell sx={{padding: '10px', width: '15%'}}>{moment(expense.invoice_date).format(DATE_FORMAT)}</TableCell>
                  <TableCell sx={{padding: '10px', width: '15%'}}>${expense.invoice_pricing}</TableCell>
                </TableRow>
              ))}
						</TableBody>
					</Table>
				</div>
			</CustomModal>
		)
	}

	const renderManualTableEditModal = () => {
		if(!manualModalSelectedValue)
			return null

		return (
			<CustomModal
				show={showManualEntryModal}
				handleClose={() => setShowManualEntryModal(false)}
				containerWidth={window.innerWidth / 2.5}
				containerHeight={window.innerHeight / 2}
			>
				<div style={{
					width: '100%',
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					height: '100%'
				}}>
					<label style={{width: '100%', textAlign: 'center', fontSize: CONSTANTS.headerSize, fontWeight: 'bold', color: Colors.primaryTextColor}}>{manualModalString}</label>
					<CustomTextFieldNew
						marginTop={20}
						width={'50%'}
						label={manualModalEntryPlaceholder}
						placeholder={`...`}
						value={manualModalEntryValue}
						onChange={(text) => {
							if (Helpers.checkIfNumber(text)) {
								setManualModalEntryValue(text)
							}
						}}
					/>

					<CustomButtonContained
						text={'Confirm Change'}
						onClick={() => {
							let temp = Object.assign({}, manualTableData)
							temp[manualModalSelectedValue[0]][manualModalSelectedValue[1]] = manualModalEntryValue
							setManualTableData(temp)
							setManualModalEntryPlaceholder('')
							setManualModalString('')
							setManualModalSelectedValue(null)
							setManualModalEntryValue('')
							setShowManualEntryModal(false)
						}}
						style={{position: 'absolute', bottom: 10}}
						color={'primary'}
					/>
				</div>
			</CustomModal>
		)
	}

	const renderEditModal = () => {
		return (
			<CustomModal
				show={showEditModal}
				handleClose={() => setShowEditModal(false)}
				containerWidth={window.innerWidth / 2.5}
			>
				<div style={{
					width: '100%',
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					height: '100%'
				}}>
					<label style={{width: '100%', textAlign: 'center', fontSize: CONSTANTS.headerSize, fontWeight: 'bold', color: Colors.primaryTextColor}}>Edit {editFieldDisplay}</label>
					<CustomTextFieldNew
						marginTop={20}
						width={'50%'}
						label={`${editFieldDisplay} ($)`}
						placeholder={`enter ${editFieldDisplay} value`}
						value={editFieldValue}
						onChange={(text) => {
							if (Helpers.checkIfNumber(text)) {
								setEditFieldValue(text)
								setManualValueChanged(0)
							}
						}}
					/>

					{
						editFieldName !== 'rental_income' &&
						<>
							<label style={{margin: 10, color: Colors.primaryTextColor, fontSize: 20}}>OR</label>

							<CustomTextFieldNew
								width={'50%'}
								label={`${editFieldDisplay} (%)`}
								placeholder={`enter ${editFieldDisplay} percentage`}
								value={editFieldPercent}
								onChange={(text) => {
									if (Helpers.checkIfNumber(text)) {
										setEditFieldPercent(text)
										setManualValueChanged(1)
									}
								}}
							/>
						</>
					}

					<CustomButtonContained
						text={'Confirm Change'}
						onClick={editFieldName === 'rental_income'? onManualRentalIncomeChanged : onEditConfirmClicked}
						style={{position: 'absolute', bottom: 10}}
						color={'primary'}
					/>


				</div>
			</CustomModal>
		)
	}

	const renderRentalComps = () => {

		return (
			<div style={{width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
				<div style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap'}}>
					{renderRentalCompsSearchFields('Radius Miles', 'radius', 'radius')}
					{renderRentalCompsSearchFields('Bedrooms Range', 'bedrooms', 'bedrooms_range')}
					{renderRentalCompsSearchFields('Bathrooms Range', 'bathrooms', 'bathrooms_range')}
					{renderRentalCompsSearchFields('Living Area Range', 'living area range', 'area_range', 200)}
					{renderRentalCompsSearchFields('Year Built Range', 'year built range', 'year_range', 200)}
					{renderRentalCompsSearchFields('Max # Comps', 'max # comps', 'max_comps')}
				</div>

				<p style={{color: Colors.primaryTextColor, fontWeight: 'bold', fontSize: 16, marginTop: 20, marginBottom: 10}}>Subject Property Details</p>
				<div style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap'}}>
					{renderRentalCompsSearchFields('Latitude', 'latitude', 'latitude')}
					{renderRentalCompsSearchFields('Longitude', 'longitude', 'longitude')}
					{renderRentalCompsSearchFields('Bedrooms', 'bedrooms', 'subject_bed')}
					{renderRentalCompsSearchFields('Bathrooms', 'bathrooms', 'subject_bath')}
					{renderRentalCompsSearchFields('Year', 'year', 'subject_year')}
					{renderRentalCompsSearchFields('Living Area', 'area', 'subject_area')}

				</div>
				<div style={{width: '98%', display: "flex", flexDirection: 'row', justifyContent: 'flex-end', marginTop: 20}}>
					<CustomButtonContained
						text={'Search Rental Comps'}
						onClick={searchRentalCompsClicked}
						style={{}}
						color={'primary'}
					/>
				</div>

				{
					loadingRentalComps?
						<CustomLoaderSpinner />
						:
						zillowRentalCompsData?.length > 0 ?
							renderZillowRentalCompsResult()
							:
							<p className={GeneralStyles.darkText} style={{marginTop: 40, width: '100%', textAlign: 'center'}}>Nothing to display</p>
				}
			</div>
		)
	}

	const handleExpandChange = (id) => {
		if(expanded.includes(id)) {
			//close it
			let temp = expanded.filter(item => item !== id)
			setExpanded(temp)
		} else {
			//add it
			let temp = [...expanded, id]
			setExpanded(temp)
		}
	}

	const renderLoanOptions = () => {
		if(!assumptions) return null
		let dscr_tiers = assumptions?.underwriting?.dscr_tiers || []

		let selectedAmount1 = Number(((NOIMan - Number(mortgage))/dscr_tiers[0]).toFixed(2))
		let selectedAmount2 = Number(((NOIMan - Number(mortgage))/dscr_tiers[1]).toFixed(2))


		let {rates} = assumptions
		let sixMonthRate = rates['6']['benchmark'] + rates['6']['spread']
		let nineMonthRate = rates['9']['benchmark'] + rates['9']['spread']
		let twelveMonthRate = rates['12']['benchmark'] + rates['12']['spread']
		let eighteenMonthRate = rates['18']['benchmark'] + rates['18']['spread']
		let perMonthAmount1 = selectedAmount1/12
		let perMonthAmount2 = selectedAmount2/12

		let actualAmount1 = Number(selectedAmount1)
		let actualAmount2 = Number(selectedAmount2)
		let actualManualAmount = Number(manualLoanAmount)
		//if the loan fee option is selected, add the appropriate amount as well
		if(loanFeeOption?.value === 0) {
			actualAmount1 += Number(loanFee)
			actualAmount2 += Number(loanFee)
			actualManualAmount += Number(loanFee)
		} else if(loanFeeOption?.value === 1) {
			let percent1 = (Number(loanFee)/100) * actualAmount1
			let percent2 = (Number(loanFee)/100) * actualAmount2
			let percentManual = (Number(loanFee) / 100) * actualManualAmount
			actualAmount1 += percent1
			actualAmount2 += percent2
			actualManualAmount += percentManual
		}
		let perMonthActualAmount1 = actualAmount1 / 12
		let perMonthActualAmount2 = actualAmount2 / 12
		let perMonthActualManualAmount = actualManualAmount / 12

		return (
			<div style={{
				width: '100%',
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
			}}>
				<div style={{display:'flex', flexDirection: 'row', alignItems: 'center', width: '100%', justifyContent: 'center'}}>
					<p style={{color: Colors.primaryTextColor, fontSize: Constants.labelSize}}>{`Tier 1 - ${Number(dscr_tiers[0]).toFixed(2)} DSCR`}</p>
					<p style={{color: Colors.primaryTextColor, fontSize: Constants.labelSize, marginLeft: 20}}>Net Income Used:<span style={{fontWeight: 'normal', marginLeft: 10}}>${Helpers.getFormattedNumber(Number(selectedAmount1.toFixed(2)))}</span></p>
					<p style={{color: Colors.primaryTextColor, fontSize: Constants.labelSize, marginLeft: 20}}>Per Month Amount:<span style={{fontWeight: 'normal', marginLeft: 10}}>${Helpers.getFormattedNumber(Number(perMonthAmount1.toFixed(2)))}</span></p>
				</div>

				<div style={{display:'flex', flexDirection: 'row', alignItems: 'center', width: '100%', justifyContent: 'center'}}>
					<p style={{color: Colors.primaryTextColor, fontSize: Constants.labelSize}}>{`Tier 2 - ${Number(dscr_tiers[1]).toFixed(2)} DSCR`}</p>
					<p style={{color: Colors.primaryTextColor, fontSize: Constants.labelSize, marginLeft: 20}}>Net Income Used :<span style={{fontWeight: 'normal', marginLeft: 10}}>${Helpers.getFormattedNumber(Number(selectedAmount2.toFixed(2)))}</span></p>
					<p style={{color: Colors.primaryTextColor, fontSize: Constants.labelSize, marginLeft: 20}}>Per Month Amount:<span style={{fontWeight: 'normal', marginLeft: 10}}>${Helpers.getFormattedNumber(Number(perMonthAmount2.toFixed(2)))}</span></p>
				</div>

				<div style={{width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 20}}>
					<p className={GeneralStyles.darkText}>Loan Points/Fee</p>
					<div
						className={GeneralStyles.boxShadow}
						style={{width: 200, height: 40, borderRadius: 10, marginLeft: 20}}>
						<CustomSelect
							isSearchable={false}
							placeholder={'select'}
							borderColor={'transparent'}
							value={loanFeeOption}
							options={[{label: 'Fixed', value: 0}, {label: 'Percent', value: 1}]}
							onChange={(selected) => {
								setLoanFeeOption(selected)
								if(selected?.value === 0)
									setLoanFee(Number(assumptions?.pricing?.loan_fee?.fixed).toFixed(2));
								else
									setLoanFee(Number(assumptions?.pricing?.loan_fee?.percent).toFixed(2));
							}}
						/>
					</div>

					{getLoanFeeInputBox()}

				</div>


				<p style={{color: Colors.primaryTextColor, fontSize: Constants.headerSize, fontWeight: 'bold', marginTop: 20}}>Repayment Plan</p>
				<p style={{color: Colors.primaryTextColor, fontSize: Constants.labelSize, marginTop: 10, width: '100%', textAlign: 'center'}}>{`Tier 1 - ${dscr_tiers[0]} DSCR`}</p>
				<div style={{display:'flex', flexDirection: 'row', alignItems: 'center', width: '100%', marginTop: 10, justifyContent: 'center'}}>
					<p style={{color: Colors.primaryTextColor, fontSize: Constants.labelSize, }}>Net Income Used(with loan fee):<span style={{fontWeight: 'normal', marginLeft: 10}}>${Helpers.getFormattedNumber(Number(actualAmount1.toFixed(2)))}</span></p>
					<p style={{color: Colors.primaryTextColor, fontSize: Constants.labelSize, marginLeft: 20}}>Per Month Amount(with loan fee):<span style={{fontWeight: 'normal', marginLeft: 10}}>${Helpers.getFormattedNumber(Number(perMonthActualAmount1.toFixed(2)))}</span></p>
				</div>
				{
					Number(dscr_tiers[0]) > Number(dscr_tiers[1]) ?
						renderLoanTable(perMonthActualAmount1, sixMonthRate, nineMonthRate, twelveMonthRate, eighteenMonthRate)
						:
						renderLoanTable(perMonthActualAmount1, sixMonthRate+1, nineMonthRate+1, twelveMonthRate+1, eighteenMonthRate+1)
				}

				<p style={{color: Colors.primaryTextColor, fontSize: Constants.labelSize, marginTop: 25, width: '100%', textAlign: 'center'}}>{`Tier 2 - ${dscr_tiers[1]} DSCR`}</p>
				<div style={{display:'flex', flexDirection: 'row', alignItems: 'center', width: '100%', marginTop: 10, justifyContent: 'center'}}>
					<p style={{color: Colors.primaryTextColor, fontSize: Constants.labelSize,}}>Net Income Used(with loan fee):<span style={{fontWeight: 'normal', marginLeft: 10}}>${Helpers.getFormattedNumber(Number(actualAmount2.toFixed(2)))}</span></p>
					<p style={{color: Colors.primaryTextColor, fontSize: Constants.labelSize,marginLeft: 20}}>Per Month Amount(with loan fee):<span style={{fontWeight: 'normal', marginLeft: 10}}>${Helpers.getFormattedNumber(Number(perMonthActualAmount2.toFixed(2)))}</span></p>
				</div>
				{
					Number(dscr_tiers[1]) > Number(dscr_tiers[0]) ?
						renderLoanTable(perMonthActualAmount2, sixMonthRate, nineMonthRate, twelveMonthRate, eighteenMonthRate)
						:
						renderLoanTable(perMonthActualAmount2, sixMonthRate+1, nineMonthRate+1, twelveMonthRate+1, eighteenMonthRate+1)

				}

				{/*<p style={{color: Colors.primaryTextColor, fontSize: Constants.labelSize, marginTop: 40, width: '100%'}}>Tier 3(margin 2%)</p>*/}
				{/*{renderLoanTable(perMonthActualAmount, sixMonthRate+2, nineMonthRate+2, twelveMonthRate+2, eighteenMonthRate+2)}*/}

				<p style={{color: Colors.primaryTextColor, fontSize: Constants.labelSize, marginTop: 40, width: '100%', textAlign: 'center'}}>Manual Loan Creation</p>
				{/*<div style={{width: '100%', marginTop: 10}}>*/}
				{/*	<CustomTextFieldNew*/}
				{/*		width={'20%'}*/}
				{/*		label={`Loan Amount ($)`}*/}
				{/*		placeholder={`enter loan amount`}*/}
				{/*		value={manualLoanAmount}*/}
				{/*		onChange={(text) => {*/}
				{/*			if (Helpers.checkIfNumber(text)) {*/}
				{/*				setManualLoanAmount(text)*/}
				{/*			}*/}
				{/*		}}*/}
				{/*	/>*/}
				{/*</div>*/}
				{/*<div style={{display:'flex', flexDirection: 'row', alignItems: 'center', width: '100%', marginTop: 10, justifyContent: 'center'}}>*/}
				{/*	<p style={{color: Colors.primaryTextColor, fontSize: Constants.labelSize,}}>Manual Amount(with loan fee):<span style={{fontWeight: 'normal', marginLeft: 10}}>${Helpers.getFormattedNumber(Number(actualManualAmount.toFixed(2)))}</span></p>*/}
				{/*	<p style={{color: Colors.primaryTextColor, fontSize: Constants.labelSize,marginLeft: 20}}>Per Month Amount(with loan fee):<span style={{fontWeight: 'normal', marginLeft: 10}}>${Helpers.getFormattedNumber(Number(perMonthActualManualAmount.toFixed(2)))}</span></p>*/}
				{/*</div>*/}
				{renderManualLoanTable()}


			</div>
		)
	}

	const renderContent = () => {
		return (
			<div style={{height: '89vh', overflowY: 'scroll'}}>
				<Accordion
					sx={{boxShadow: '0px 4px 15px 0px #00000066', border: '1px solid #E7E7E7', marginTop: 2}}
					expanded={expanded.includes(EXPANDABLE_ROWS.work_order_details)}
					onChange={() => handleExpandChange(EXPANDABLE_ROWS.work_order_details)}>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon style={{color: Colors.primaryTextColor}}/>}
						aria-controls="work_order_details_content"
						id="work_order_details_content"
						sx={{height: 40}}
					>
						<p className={GeneralStyles.darkText} style={{fontWeight: 'bold'}}>Work Order Details & Revela Property Details</p>
					</AccordionSummary>
					<AccordionDetails>
						<div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%'}}>
							{/*work order details*/}
							{renderWorkOrderDetails()}
							{renderPropertyDetails()}
						</div>
					</AccordionDetails>
				</Accordion>


				<Accordion
					sx={{boxShadow: '0px 4px 15px 0px #00000066', border: '1px solid #E7E7E7', marginTop: 2}}
					expanded={expanded.includes(EXPANDABLE_ROWS.third_party_details)}
					onChange={() => handleExpandChange(EXPANDABLE_ROWS.third_party_details)}>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon style={{color: Colors.primaryTextColor}}/>}
						aria-controls="third_party_details_content"
						id="third_party_details_content"
						sx={{height: 40}}
					>
						<p className={GeneralStyles.darkText} style={{fontWeight: 'bold'}}>ATTOM & Zillow Data</p>
					</AccordionSummary>
					<AccordionDetails>
						<div style={{width: '100%', display: 'flex', flexDirection: 'row'}}>
							{renderAttomAndZillowData()}
						</div>
					</AccordionDetails>
				</Accordion>

				<Accordion
					sx={{boxShadow: '0px 4px 15px 0px #00000066', border: '1px solid #E7E7E7', marginTop: 2}}
					expanded={expanded.includes(EXPANDABLE_ROWS.attom_sales_comps)}
					onChange={() => handleExpandChange(EXPANDABLE_ROWS.attom_sales_comps)}>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon style={{color: Colors.primaryTextColor}}/>}
						aria-controls="attom_comps_content"
						id="attom_comps_content"
						sx={{height: 40}}
					>
						<p className={GeneralStyles.darkText} style={{fontWeight: 'bold'}}>ATTOM Sales Comps</p>
					</AccordionSummary>
					<AccordionDetails>
						{renderAttomSalesComps()}
					</AccordionDetails>
				</Accordion>

				<Accordion
					sx={{boxShadow: '0px 4px 15px 0px #00000066', border: '1px solid #E7E7E7', marginTop: 2}}
					expanded={expanded.includes(EXPANDABLE_ROWS.zillow_sales_comps)}
					onChange={() => handleExpandChange(EXPANDABLE_ROWS.zillow_sales_comps)}>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon style={{color: Colors.primaryTextColor}}/>}
						aria-controls="zillow_comps_content"
						id="zillow_comps_content"
						sx={{height: 40}}
					>
						<p className={GeneralStyles.darkText} style={{fontWeight: 'bold'}}>Zillow Sales Comps</p>
					</AccordionSummary>
					<AccordionDetails>
						{renderZillowSalesComps()}
					</AccordionDetails>
				</Accordion>


				<Accordion
					sx={{boxShadow: '0px 4px 15px 0px #00000066', border: '1px solid #E7E7E7', marginTop: 2}}
					expanded={expanded.includes(EXPANDABLE_ROWS.rental_comps)}
					onChange={() => handleExpandChange(EXPANDABLE_ROWS.rental_comps)}>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon style={{color: Colors.primaryTextColor}}/>}
						aria-controls="comps_content"
						id="comps_content"
						sx={{height: 40}}
					>
						<p className={GeneralStyles.darkText} style={{fontWeight: 'bold'}}>Rental Comps</p>
					</AccordionSummary>
					<AccordionDetails>
						{renderRentalComps()}
					</AccordionDetails>
				</Accordion>




				<Accordion
					sx={{boxShadow: '0px 4px 15px 0px #00000066', marginTop: 2}}
					expanded={expanded.includes(EXPANDABLE_ROWS.income_details)}
					onChange={() => handleExpandChange(EXPANDABLE_ROWS.income_details)}>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon style={{color: Colors.primaryTextColor}}/>}
						aria-controls="income_details_content"
						id="income_details_content"
						sx={{height: 40}}
					>
						<p className={GeneralStyles.darkText} style={{fontWeight: 'bold'}}>Operating Income Details</p>
					</AccordionSummary>
					<AccordionDetails>
						<div style={{width: '100%'}}>
							{renderNOIMarginDetails()}
						</div>
					</AccordionDetails>
				</Accordion>

				<Accordion
					sx={{boxShadow: '0px 4px 15px 0px #00000066', border: '1px solid #E7E7E7', marginTop: 2}}
					expanded={expanded.includes(EXPANDABLE_ROWS.loan_tiers)}
					onChange={() => handleExpandChange(EXPANDABLE_ROWS.loan_tiers)}>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon style={{color: Colors.primaryTextColor}}/>}
						aria-controls="loan_tiers_content"
						id="loan_tiers_content"
						sx={{height: 40}}
					>
						<p className={GeneralStyles.darkText} style={{fontWeight: 'bold'}}>Loan Tiers For Reference</p>
					</AccordionSummary>
					<AccordionDetails>
						<div style={{width: '100%'}}>
							<LoanTiersTable />
						</div>
					</AccordionDetails>
				</Accordion>

				<Accordion
					sx={{boxShadow: '0px 4px 15px 0px #00000066', border: '1px solid #E7E7E7', marginTop: 2}}
					expanded={expanded.includes(EXPANDABLE_ROWS.loan_options)}
					onChange={() => handleExpandChange(EXPANDABLE_ROWS.loan_options)}>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon style={{color: Colors.primaryTextColor}}/>}
						aria-controls="loan_options_content"
						id="loan_options_content"
						sx={{height: 40}}
					>
						<p className={GeneralStyles.darkText} style={{fontWeight: 'bold'}}>Loan Options & Repayment Plan</p>
					</AccordionSummary>
					<AccordionDetails>
						{renderLoanOptions()}
					</AccordionDetails>
				</Accordion>



				{renderManualTableEditModal()}
				{renderEditModal()}
				{renderIncomeModal()}
				{renderExpensesModal()}
				{renderPhotosModal()}
			</div>
		)
	}

	const getButtons = () => {
		if(!activeUnderwriting || activeUnderwritingId === -1)
			return null
		if (activeUnderwriting.status === WORK_ORDER_STATUSES.NEW) {
			return (
				<div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
					<CustomButtonContained
						style={{marginLeft: 2}}
						text={'Engage'}
						onClick={() => updateWorkOrderStatusClicked(WORK_ORDER_STATUSES.ENGAGING)}
						color={'primary'}
					/>
					<CustomButtonContained
						style={{marginLeft: 2}}
						text={'Ignore'}
						onClick={() => updateWorkOrderStatusClicked(WORK_ORDER_STATUSES.IGNORED)}
						color={'primary'}
					/>
				</div>
			)
		} else if (activeUnderwriting.status === WORK_ORDER_STATUSES.ENGAGING) {
			return (
				<div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
					<CustomButtonContained
						style={{marginLeft: 2}}
						text={'Move to New'}
						onClick={() => updateWorkOrderStatusClicked(WORK_ORDER_STATUSES.NEW)}
						color={'primary'}
					/>
					<CustomButtonContained
						style={{marginLeft: 2}}
						text={'Ignore'}
						onClick={() => updateWorkOrderStatusClicked(WORK_ORDER_STATUSES.IGNORED)}
						color={'primary'}
					/>
				</div>
			)
		} else if (activeUnderwriting.status === WORK_ORDER_STATUSES.IGNORED) {
			return (
				<div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
					<CustomButtonContained
						style={{marginLeft: 2}}
						text={'Move to New'}
						onClick={() => updateWorkOrderStatusClicked(WORK_ORDER_STATUSES.NEW)}
						color={'primary'}
					/>
					<CustomButtonContained
						style={{marginLeft: 2}}
						text={'Engage'}
						onClick={() => updateWorkOrderStatusClicked(WORK_ORDER_STATUSES.ENGAGING)}
						color={'primary'}
					/>
				</div>
			)
		}
	}

	return (
		<div className={GeneralStyles.container} style={{overflowY: 'hidden'}}>
			<div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', position: 'relative' }}>
				<PageHeader header={'Underwriting Details'} />
				<div style={{
					position: 'absolute',
					right: 0,
					display: 'flex',
					flexDirection: 'row',
					alignItems: 'center'
				}}>
					{activeUnderwritingId !== -1 && <label style={{color: Colors.secondaryTextColor, textDecoration: 'underline'}}>Status: {activeUnderwriting?.status}</label>}
					{getButtons()}
					<ArrowBackIcon onClick={onBackClicked} style={{marginLeft: 20, height: 30, width: 30, cursor: 'pointer'}}/>
				</div>

			</div>

			<PositionedSnackbar
				onClose={() => {
					setShowError(false)
					setShowSuccess(false)
					setErrorMessage('')
					setSuccessMessage('')
				}}
				severity={showError ? 'error' : 'success'}
				openFlag={showError || showSuccess}
				message={showError ? errorMessage : successMessage}
			/>

			{
				loading ?
					<div style={{ height: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%'}}>
						<CustomLoaderSpinner />
					</div>
					:
					renderContent()
			}
		</div>
	);
}

const MortgageEstimate = ({mortgageAmount, loanTerm, date}) => {
	const mortgageRates15 = useSelector(state => state.settings.mortgage_rates_15)
	const mortgageRates30 = useSelector(state => state.settings.mortgage_rates_30)

	const [showError, setShowError] = useState(false)
	const [errorMessage, setErrorMessage] = useState('')
	const [amount, setAmount] = useState('')
	const [interest, setInterest] = useState('')
	const [term, setTerm] = useState('')
	const [startDate, setStartDate] = useState(new Date())
	const [tempDate, setTempDate] = useState(new Date())
	const [showDateModal, setShowDateModal] = useState(false)
	const [mortgageRateDate, setMortgageDate] = useState(null)
	const [monthlyPayment, setMonthlyPayment] = useState(null)

	useEffect(() => {
		if(mortgageAmount && Helpers.checkIfNumber(mortgageAmount))
			setAmount(mortgageAmount)
	}, [mortgageAmount]);

	useEffect(() => {
		if(loanTerm && Helpers.checkIfNumber(loanTerm)) {
			setTerm(loanTerm)
		}

	}, [loanTerm]);

	useEffect(() => {
		if(date) {
			setStartDate(date)
			setTempDate(date)
		}
	}, [date]);

	const getTermYears = (term) => {
		if(term >= 358 && term <= 362)
			return 30
		else if(term >= 178 && term <= 182)
			return 15
		else
			return null
	}

	useEffect(() => {
		if(
			!mortgageRates15
			|| !mortgageRates30
			|| mortgageRates30.length === 0
			|| mortgageRates15.length === 0
			|| !term
			|| term.length === 0
			|| !Helpers.checkIfNumber(term)) return


		let array = null
		if(getTermYears(term) === 30) {
			array = mortgageRates30
		} else if(getTermYears(term) === 15) {
			array = mortgageRates15
		}

		if(array) {
			let {mortgageRate, mortgageDate} = getRightMortgageRate(array,  startDate)
			setInterest(mortgageRate)
			setMortgageDate(mortgageDate)
		} else {
			setErrorMessage('No mortgage rate found for this term and date')
      setShowError(true)
			setInterest('')
			setMortgageDate(null)
		}

	}, [mortgageRates15, mortgageRates30, startDate, term]);

	const getRightMortgageRate = (array, date) => {
		let mortgageRate = null
		let mortgageDate = null
		array.every((entry) => {
			if(moment(entry.date).isBefore(moment(date))) {
				mortgageRate = entry.value
				mortgageDate = entry.date
				return true
			} else {
				return false
			}
		})

		return {mortgageRate, mortgageDate}
	}

	const onEstimateMortageClicked = () => {
		if(!amount || isNaN(amount)) {
			setErrorMessage('Please enter a valid principal amount')
			setShowError(true)
			return
		}

		if(!interest || isNaN(interest)) {
			setErrorMessage('Please enter a valid annual interest rate')
			setShowError(true)
			return
		}

		if(!term || isNaN(term)) {
			setErrorMessage('Please enter a valid term in years')
			setShowError(true)
			return
		}

		let temp = Helpers.calculateMonthlyPayment(Number(amount), Number(interest)/100, Number(term))
		setMonthlyPayment(Number(temp))
	}


	const renderDateModal = () => {
		return (
			<CustomModal
				show={showDateModal}
				handleClose={() => setShowDateModal(false)}
				containerWidth={window.innerWidth/2}
				containerHeight={window.innerHeight/2}
			>
				<div style={{
					width: '100%',
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					height: '100%',
					position: 'relative'
				}}>
					<label
						style={{
							width: '100%',
							textAlign: 'center',
							fontSize: CONSTANTS.headerSize,
							fontWeight: 'bold',
							color: Colors.primaryTextColor
					}}>
						Select Start Date
					</label>

					<Calendar
						date={tempDate}
						onChange={setTempDate}
					/>

					<CustomButtonContained
						text={'Confirm Date'}
						onClick={() => {
							setStartDate(tempDate)
							setShowDateModal(false)
						}}
						style={{position:'absolute', bottom: 20}}
						color={'primary'}
					/>




				</div>
			</CustomModal>
		)
	}

	const getMortgageDateAndRateString = () => {
		if(!mortgageRateDate ||!interest) return null

		if(getTermYears(term) === 30) {
			return (
				<p style={{color: Colors.primaryTextColor, fontSize: 14, fontWeight: 'bold', width: '100%', marginLeft: 10}}>
					30 Year Mortgage Rate Date : <span style={{fontWeight: 'normal'}}>{`${moment(mortgageRateDate).format(DATE_FORMAT)}(${interest}%)`}</span>
				</p>
			)
		} else if(getTermYears(term) === 15) {
			return (
				<p style={{color: Colors.primaryTextColor, fontSize: 14, fontWeight: 'bold', width: '100%', marginLeft: 10}}>
					15 Year Mortgage Rate Date : <span style={{fontWeight: 'normal'}}>{`${moment(mortgageRateDate).format(DATE_FORMAT)}(${interest}%)`}</span>
				</p>
			)
		}


	}

	const renderTable = () => {
		if(!monthlyPayment || monthlyPayment === 0 || !term || !Helpers.checkIfNumber(term)) return null


		let array = [{balance: Number(amount), principal: 0, interest: 0}]
		for(let i=1;i<=Number(term); i++) {
			let interestToPay = array[i-1].balance * Number(interest) / 1200
			let principalToPay = monthlyPayment - interestToPay
			array.push({balance: array[i-1].balance - principalToPay, principal: principalToPay, interest: interestToPay})
		}

		let elements = array.map((entry, index) => {
			return (
				<TableRow key={index.toString()}>
					<TableCell scope="row" sx={{padding: '10px', width: '5%'}}>{index}</TableCell>
					<TableCell scope="row" sx={{padding: '10px', width: '19%'}}>{moment(startDate).add(index, 'months').format(DATE_FORMAT)}</TableCell>
					<TableCell scope="row" sx={{padding: '10px', width: '30%'}}>${Helpers.getFormattedNumber(entry.balance.toFixed(2))}</TableCell>
					<TableCell scope="row" sx={{padding: '10px', width: '23%'}}>${Helpers.getFormattedNumber(entry.principal.toFixed(2))}</TableCell>
					<TableCell scope="row" sx={{padding: '10px', width: '23%'}}>${Helpers.getFormattedNumber(entry.interest.toFixed(2))}</TableCell>
				</TableRow>
			)
		})

		return (
			<div style={{width: '100%'}}>
				<CustomButtonContained
					text={'Cancel'}
					onClick={() => {
						setMonthlyPayment(null)
					}}
					style={{marginBottom: 2}}
					color={'secondary'}
				/>

				<Table sx={{ width: '100%'}} aria-label="simple table">
					<TableHead>
						<TableRow>
							<TableCell sx={{padding: '10px', width: '5%'}}>#</TableCell>
							<TableCell sx={{padding: '10px', width: '19%'}}>Date</TableCell>
							<TableCell sx={{padding: '10px', width: '30%'}}>Balance</TableCell>
							<TableCell sx={{padding: '10px', width: '23%'}}>Principal</TableCell>
							<TableCell sx={{padding: '10px', width: '23%'}}>Interest</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{elements}
					</TableBody>
				</Table>
			</div>
		)
	}

	return (
		<div style={{width: '100%'}}>
			<PositionedSnackbar
				onClose={() => {
					setShowError(false)
					setErrorMessage('')
				}}
				severity={'error'}
				openFlag={showError}
				message={errorMessage}
			/>

			<div style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap', marginTop: 4}}>
				<CustomTextFieldNew
					margin={8}
					width={180}
					label={'Mortgage Amount($)'}
					placeholder={'enter amount'}
					value={amount}
					onChange={(text) => {
						if (Helpers.checkIfNumber(text)) {
							setAmount(text)
						}
					}}
				/>

				<CustomTextFieldNew
					margin={8}
					width={180}
					label={'Loan Term(months)'}
					placeholder={'enter loan term'}
					value={term}
					onChange={(text) => {
						if (Helpers.checkIfNumber(text)) {
							setTerm(text)
						}
					}}
				/>

				<CustomTextFieldNew
					margin={8}
					width={180}
					label={'Annual Interest Rate(%)'}
					placeholder={'enter interest rate'}
					value={interest}
					onChange={(text) => {
						if (Helpers.checkIfNumber(text)) {
							setInterest(text)
						}
					}}
				/>

				<div
					onClick={() => setShowDateModal(true)}
					className={GeneralStyles.boxShadow}
					style={{width: 180, height: 50, borderRadius: 10, display: 'flex', flexDirection: 'column', cursor: 'pointer', margin: 8, paddingLeft: 10, paddingTop: 2}}>
					<label style={{color: Colors.primaryTextColor, fontWeight: '600', fontSize: 14}}>Start Date</label>
					<p style={{fontSize: Constants.entryTextSize}} className={GeneralStyles.darkText}>
						{moment(startDate).format(DATE_FORMAT)}
					</p>
				</div>

			</div>
			{getMortgageDateAndRateString()}

			<CustomButtonContained
				text={'Estimate Mortgage'}
				onClick={onEstimateMortageClicked}
				style={{marginTop: 2}}
				color={'primary'}
			/>

			{
				monthlyPayment && Helpers.checkIfNumber(monthlyPayment) &&
				<div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', marginTop: 20, marginBottom: 10}}>
					<p style={{color: Colors.primaryTextColor, fontSize: 14, fontWeight: 'bold', width: '48%'}}>
						Monthly Payment : <span style={{fontWeight: 'normal'}}>{Helpers.getFormattedNumber(Number(monthlyPayment.toFixed(2)))}</span>
					</p>
					<p style={{color: Colors.primaryTextColor, fontSize: 14, fontWeight: 'bold', width: '48%', textAlign: 'right'}}>
						Yearly Payment : <span style={{fontWeight: 'normal'}}>{Helpers.getFormattedNumber(Number((monthlyPayment*12).toFixed(2)))}</span>
					</p>
				</div>
			}

			{renderTable()}

			{renderDateModal()}

		</div>
	)
}



